import {GenericoService} from '../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {ClsConfig} from '../../../util/cls-config';
import {ClsUtil} from '../../../util/cls-util';
import {EnumTipoExpIns} from '../../../core/models/enum/enum-exp-insumos';
import {EnumLibros, EnumParaPpto} from '../../../core/models/enum/enum-parametros';
import {CalculoComponent} from '../../../componentes/01-presupuesto/calculo/calculo.component';
import {ClsPeticionPresupuestos} from '../../../core/models/peticiones/cls-pr-generico';
import {ClsObjSobrecosto} from '../presupuesto/cls-obj-sobrecosto';
import {
  ClsPeticionCatalogoDetalleCostosRegistraActualiza2021,
  ClsPeticionExpinsXconcepto,
  ClsPeticionFechaMonedas,
  ClsPeticionGuardarCatalogo,
  ClsPeticionGuardarExpXConceptos,
  ClsPeticionGuardarPartidas,
  ClsPeticionTasaInteresMonedas
} from '../../../core/models/peticiones/cls-pr-calculo';
import {ClsObjCostoHorario} from '../presupuesto/cls-obj-costo-horario';
import {ClsObjMatrices} from '../matrices/cls-obj-matrices';
import {Worksheet} from 'igniteui-angular-excel';
import {EnumTipoTchFij} from '../../../core/models/enum/enum-costos-horarios';
import {EnumTipoParametro} from '../../../core/models/enum/enum-tipo-parametro';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {Stack} from 'src/app/core/models/stack';
import {ClsArchivosEntrada, ClsListaArchivos} from "../../../core/models/cls-storage";
import {
  ClsCalculoCatalogo,
  ClsCalculoDetalleExpXConcepto,
  ClsCalculoGuardarCatalogo,
  ClsCalculoGuardarPartidas,
  ClsCalculoMatriz,
  ClsCalculoOrderNivel,
  ClsCalculoPartidas,
  ClsCalculoPresupuesto,
  ClsCatalogoCalculo,
  ClsCatalogoCostosCalculo,
  ClsCatalogoCostosOPCalculo,
  ClsCatalogoMOCalculo,
  ClsConceptosPartidasGuardar
} from "../../../core/models/cls-calculo";
import {ClsCatalogosExpIns} from "../../../core/models/cls-catalogo-general";
import {
  ClsCostoHorarios,
  ClsLsJsonCostosHorariosMO,
  ClsLsJsonCostosHorariosOC
} from "../../../core/models/cls-costo-horarios";
import {ClsMatriz} from "../../../core/models/cls-matriz";
import {ClsParametro} from "../../../core/models/cls-parametros";
import {ClsErrores} from "../../../core/models/cls-errores";
import {inject} from "@angular/core";
import {ExcelUtility} from "../../../util/excel-utility";
import {ClsObjMateriales} from "../menu-presupuesto/cls-obj-materiales";
import {ClsMaterialesMoneda} from "../../../core/models/cls-materiales";
import {ClsObjManoDeObra} from "../menu-presupuesto/cls-obj-mano-de-obra";
import {ClsManoDeObraMoneda} from "../../../core/models/cls-mano-de-obra";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {ClsPorcentajesFinanciamiento, ClsPrograma} from '../../../core/models/cls-programa';
import {
  ClsDtoResultadoProgSumExplosion,
  IJsonProgSumItem,
  IProgSumExplosionDetalle
} from '../../../core/models/peticiones/cls-pr-calculo-prog';
import {ClsObjCatProgramacionObra} from "../programacion-obra/cls-obj-cat-programacion-obra";
import {ClsConceptosPartida} from '../../../core/models/cls-partida';

export class ClsObjCalculo extends ClsConfig {
  // datos para el calculo
  private mPila = new Stack(51);
  private nivelT: number;
  // parametros
  public mTipoExplosion: EnumTipoExpIns;
  // private mErrorPotenciales: boolean;
  public mAsignarTasaIntCH: boolean;
  public mTasa: number;
  public mAsignarFecha: boolean;
  private mFechaAsignada: Date;
  public mTipoMonedaCalcular: number;
  // private mFactorM1: number;
  // private mFactorM2: number;
  public mExplosionXConcepto: boolean;
  private mTieneIndirecto: boolean;
  private mTieneLibroPieIndirecto: boolean;
  private mValorSobrecosto: number;
  public mExplotarInsumoCH: boolean;
  public mExplotarInsumosIntegrados: boolean;
  private mTotMatriz: number;
  // fin parametros
  public mTotalPre: number;
  private mTotalCos: number;
  public mTotalMOGravable: number;
  public componenteCalculo: CalculoComponent;
  // costo horario
  private mLibroCostoHorario: ClsListaArchivos;
  public mHojaCamposGenerales: Worksheet;
  public mHojaDatos: Worksheet;
  // Mapas y Arrays
  private mMapHCatalogo: Map<bigint, ClsCalculoCatalogo>;
  private mMapHMatriz: Map<bigint, ClsCalculoMatriz[]>;
  private mMapHExpInsumos: Map<bigint, ClsCatalogosExpIns>;
  private mMapHCostoCalculo: Map<bigint, ClsCatalogoCostosCalculo>;
  private mMapHCostoOPCalculo: Map<bigint, ClsCatalogoCostosOPCalculo>;
  private mLCostoOPCalculoBorrar: bigint[];
  private mMapHCostoMOCalculo: Map<bigint, ClsCatalogoMOCalculo>;
  private mDataMO: ClsManoDeObraMoneda[] = [];
  private mDataOP: ClsMaterialesMoneda[] = [];
  private mMapHExplosion: Map<bigint, number>;
  /** Explosión ajustada por partida (memoria; equivalente VB `PuExpinsPar` / `EscribeExpinsPar`). */
  private mMapHExpXPartida: Map<bigint, Map<bigint, number>> = new Map();
  /** Matrices fusionadas x partida (`mergePresupuestoMatrices`) para uso en `ExplotaProgSumPar`. */
  private mMergePresupuestoMatricesPorPartida = new Map<bigint, Map<bigint, number>>();
  private mMergePresupuestoConcentosPorPartida = new Map<bigint, Map<number, IProgSumExplosionDetalle>>();
  private mPresupuestoConcentosPorPartida = new Map<bigint, IProgSumExplosionDetalle[]>();
  private mMapCostoPrecioPeriodo: Map<number, IProgSumExplosionDetalle> = new Map<number, IProgSumExplosionDetalle>();
  private mMapHPartidas: Map<bigint, ClsCalculoPartidas>;
  // llave = idPresupuestoPartida + '-' + control
  private mMapHPartidasDet: Map<string, ClsConceptosPartidasGuardar>;
  private mMapHTipos: Map<number, number>;
  private mMapHExpXConcepto: Map<bigint, ClsCalculoDetalleExpXConcepto[]>;
  // private mMapEsperaReserva: Map<bigint, bigint>;
  private mMapCostoHorariosCF: Map<bigint, ClsCostoHorarios>;
  public mLMatrices: ClsMatriz[] = [];
  public mLCostoHorarios: ClsCostoHorarios[] = [];
  private mMapJsonConceptos: Map<bigint, ClsConceptosPartidasGuardar[]>;
  private mLPresupuesto: Array<ClsCalculoPresupuesto>;
  private mLExplosion: Array<bigint>;
  private paramSobrecosto: ClsParametro[] = [];
  // costos
  private mCosto93 = 0;
  private mCosto94 = 0;
  private mCosto95 = 0;
  private mCosto96 = 0;
  private mCosto97 = 0;
  private mCosto98 = 0;
  private mTotMA2 = 0; // total de materiales que son %
  private mTotMA3 = 0; // total de materiales de sus basicos
  private mTotMO2 = 0; // total de mano de obra que son %
  private mTotMO3 = 0; // total de la mano de obra gravable esta matriz y de sus basicos
  private mTotMoTotal = 0; // total de la mano de obra de esta matriz y sus basicos
  private mTotMoGravableEstaMatriz = 0; //  Total de la mano de obra gravable de esta matriz
  // obj
  public mObjSobrecosto: ClsObjSobrecosto;
  public mObjCostoHorario: ClsObjCostoHorario;
  public mObjMatrices: ClsObjMatrices;
  public mObjGenerico: ClsObjGenerico;
  public mObjMateriales: ClsObjMateriales;
  public mObjMO: ClsObjManoDeObra;
  private mObjProgramacionObra: ClsObjCatProgramacionObra = new ClsObjCatProgramacionObra();
  /** Calcular programa de suministros (alineado a VB objCalculo.ProgSum). */
  public mProgSum: boolean = false;
  /** Calcular programa de suministros x partida (alineado a VB objCalculo.ProgSumPar). */
  public mProgSumPar: boolean = false;
  /** Programa de obra ya obtenido por `CalculoComponent` (evita recargar al servidor). */
  public programaObra: ClsPrograma | null = null;
  /** Último resultado de `ExplotaProgSum` (p. ej. para `CalculaTotFinPre` o envío a servidor). */
  private mUltimoResultadoProgSum: ClsDtoResultadoProgSumExplosion | null = null;
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private tipoMsg = inject(TipoMensajesService);

  constructor() {
    super();
  }

  public async crearObjCostosCalculo(costosZIP: string): Promise<ClsCatalogoCostosCalculo[]> {
    const costos: ClsCatalogoCostosCalculo[] = [];
    try {
      const contenido: string = await ClsUtil.descomprimirArchivoBase64(costosZIP, 'CostosCalculo.txt');
      if (ClsUtil.esNulo(contenido)) {
        return costos;
      }
      const objCostos: string[] = ClsUtil.splitEnterNeo(contenido);
      objCostos.forEach(value => {
        const costo: ClsCatalogoCostosCalculo = new ClsCatalogoCostosCalculo();
        const filas: string[] = ClsUtil.splitTabsNeo(value);
        costo.IdCatalogo = ClsUtil.bigintX(filas[0]);
        costo.Costo93Moneda1 = ClsUtil.numberX(filas[1]);
        costo.Costo94Moneda1 = ClsUtil.numberX(filas[2]);
        costo.Costo95Moneda1 = ClsUtil.numberX(filas[3]);
        costo.Costo96Moneda1 = ClsUtil.numberX(filas[4]);
        costo.Costo97Moneda1 = ClsUtil.numberX(filas[5]);
        costo.Costo98Moneda1 = ClsUtil.numberX(filas[6]);
        costo.Costo93Moneda2 = ClsUtil.numberX(filas[7]);
        costo.Costo94Moneda2 = ClsUtil.numberX(filas[8]);
        costo.Costo95Moneda2 = ClsUtil.numberX(filas[9]);
        costo.Costo96Moneda2 = ClsUtil.numberX(filas[10]);
        costo.Costo97Moneda2 = ClsUtil.numberX(filas[11]);
        costo.Costo98Moneda2 = ClsUtil.numberX(filas[12]);
        costo.Costo93Moneda3 = ClsUtil.numberX(filas[13]);
        costo.Costo94Moneda3 = ClsUtil.numberX(filas[14]);
        costo.Costo95Moneda3 = ClsUtil.numberX(filas[15]);
        costo.Costo96Moneda3 = ClsUtil.numberX(filas[16]);
        costo.Costo97Moneda3 = ClsUtil.numberX(filas[17]);
        costo.Costo98Moneda3 = ClsUtil.numberX(filas[18]);
        costos.push(costo);
      });
      return costos;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async crearObjCostosOPCalculo(costosOPZIP: string): Promise<ClsCatalogoCostosOPCalculo[]> {
    const costosOP: ClsCatalogoCostosOPCalculo[] = [];
    try {
      const contenido: string = await ClsUtil.descomprimirArchivoBase64(costosOPZIP, 'CostosOP.txt');
      if (ClsUtil.esNulo(contenido)) {
        return costosOP;
      }
      const objCostos: string[] = ClsUtil.splitEnterNeo(contenido);
      objCostos.forEach(value => {
        const costoOP: ClsCatalogoCostosOPCalculo = new ClsCatalogoCostosOPCalculo();
        const filas: string[] = ClsUtil.splitTabsNeo(value);
        costoOP.IdCatalogo = ClsUtil.bigintX(filas[0]);
        costoOP.AlmacenajeMoneda1 = ClsUtil.numberX(filas[1]);
        costoOP.CostoLABMoneda1 = ClsUtil.numberX(filas[2]);
        costoOP.DerechosMoneda1 = ClsUtil.numberX(filas[3]);
        costoOP.FletesMoneda1 = ClsUtil.numberX(filas[4]);
        costoOP.ManiobraMoneda1 = ClsUtil.numberX(filas[5]);
        costoOP.MermasMoneda1 = ClsUtil.numberX(filas[6]);
        costoOP.AlmacenajeMoneda2 = ClsUtil.numberX(filas[7]);
        costoOP.CostoLABMoneda2 = ClsUtil.numberX(filas[8]);
        costoOP.DerechosMoneda2 = ClsUtil.numberX(filas[9]);
        costoOP.FletesMoneda2 = ClsUtil.numberX(filas[10]);
        costoOP.ManiobraMoneda2 = ClsUtil.numberX(filas[11]);
        costoOP.MermasMoneda2 = ClsUtil.numberX(filas[12]);
        costoOP.AlmacenajeMoneda3 = ClsUtil.numberX(filas[13]);
        costoOP.CostoLABMoneda3 = ClsUtil.numberX(filas[14]);
        costoOP.DerechosMoneda3 = ClsUtil.numberX(filas[15]);
        costoOP.FletesMoneda3 = ClsUtil.numberX(filas[16]);
        costoOP.ManiobraMoneda3 = ClsUtil.numberX(filas[17]);
        costoOP.MermasMoneda3 = ClsUtil.numberX(filas[18]);
        costosOP.push(costoOP);
      });
      return costosOP;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async crearObjCostosMOCalculo(costosMOZIP: string): Promise<ClsCatalogoMOCalculo[]> {
    const costosMO: ClsCatalogoMOCalculo[] = [];
    try {
      const contenido: string = await ClsUtil.descomprimirArchivoBase64(costosMOZIP, 'CostosMO.txt');
      if (ClsUtil.esNulo(contenido)) {
        return costosMO;
      }
      const objCostosMO: string[] = ClsUtil.splitEnterNeo(contenido);
      objCostosMO.forEach(value => {
        const costoMO: ClsCatalogoMOCalculo = new ClsCatalogoMOCalculo();
        const filas: string[] = ClsUtil.splitTabsNeo(value);
        costoMO.IdCatalogo = ClsUtil.bigintX(filas[0]);
        costoMO.AlimentacionYHospedajeMoneda1 = ClsUtil.numberX(filas[1]);
        costoMO.FactorSalarioIntegradoMoneda1 = ClsUtil.numberX(filas[2]);
        costoMO.FasarMoneda1 = ClsUtil.numberX(filas[3]);
        costoMO.GastosDeSepelioMoneda1 = ClsUtil.numberX(filas[4]);
        costoMO.OtrasPrestacionesMoneda1 = ClsUtil.numberX(filas[5]);
        costoMO.RiesgosdeTrabajoMoneda1 = ClsUtil.numberX(filas[6]);
        costoMO.SalarioBaseMoneda1 = ClsUtil.numberX(filas[7]);
        costoMO.SalarioIntegradoMoneda1 = ClsUtil.numberX(filas[8]);
        costoMO.SalarioRealMoneda1 = ClsUtil.numberX(filas[9]);
        costoMO.TipoFasarMoneda1 = ClsUtil.numberX(filas[10]);
        costoMO.ViaticosMoneda1 = ClsUtil.numberX(filas[11]);
        costoMO.AlimentacionYHospedajeMoneda2 = ClsUtil.numberX(filas[12]);
        costoMO.FactorSalarioIntegradoMoneda2 = ClsUtil.numberX(filas[13]);
        costoMO.FasarMoneda2 = ClsUtil.numberX(filas[14]);
        costoMO.GastosDeSepelioMoneda2 = ClsUtil.numberX(filas[15]);
        costoMO.OtrasPrestacionesMoneda2 = ClsUtil.numberX(filas[16]);
        costoMO.RiesgosdeTrabajoMoneda2 = ClsUtil.numberX(filas[17]);
        costoMO.SalarioBaseMoneda2 = ClsUtil.numberX(filas[18]);
        costoMO.SalarioIntegradoMoneda2 = ClsUtil.numberX(filas[19]);
        costoMO.SalarioRealMoneda2 = ClsUtil.numberX(filas[20]);
        costoMO.TipoFasarMoneda2 = ClsUtil.numberX(filas[21]);
        costoMO.AlimentacionYHospedajeMoneda3 = ClsUtil.numberX(filas[22]);
        costoMO.FactorSalarioIntegradoMoneda3 = ClsUtil.numberX(filas[23]);
        costoMO.FasarMoneda3 = ClsUtil.numberX(filas[24]);
        costoMO.GastosDeSepelioMoneda3 = ClsUtil.numberX(filas[25]);
        costoMO.OtrasPrestacionesMoneda3 = ClsUtil.numberX(filas[26]);
        costoMO.RiesgosdeTrabajoMoneda3 = ClsUtil.numberX(filas[27]);
        costoMO.SalarioBaseMoneda3 = ClsUtil.numberX(filas[28]);
        costoMO.SalarioIntegradoMoneda3 = ClsUtil.numberX(filas[29]);
        costoMO.SalarioRealMoneda3 = ClsUtil.numberX(filas[30]);
        costoMO.TipoFasarMoneda3 = ClsUtil.numberX(filas[31]);
        costosMO.push(costoMO);
      });
      return costosMO;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async guardarCatalogo(arrayCat: ClsCalculoGuardarCatalogo[]) {
    const objPeticion: ClsPeticionGuardarCatalogo = new ClsPeticionGuardarCatalogo();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Catalogos = arrayCat;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraCalculoCatalogo');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async guardarPartida(arrayPartidas: ClsCalculoGuardarPartidas[]) {
    const objPeticion: ClsPeticionGuardarPartidas = new ClsPeticionGuardarPartidas();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Partidas = arrayPartidas;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraCalculoPartidas');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async guardarExpXConeptos(expXConcepto: ClsPeticionExpinsXconcepto[]) {
    const objPeticion: ClsPeticionGuardarExpXConceptos = new ClsPeticionGuardarExpXConceptos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.ExpinsXconcepto = expXConcepto;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraCalculaExpinsXconcepto');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async calculaDatosParaExpIns() {
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'CalculaDatosParaExpIns');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async registraActualizaTasaInteresMonedas(tasa1: number, tasa2: number) {
    const objPeticion: ClsPeticionTasaInteresMonedas = new ClsPeticionTasaInteresMonedas();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.TasaInteresMoneda1 = tasa1;
    objPeticion.TasaInteresMoneda2 = tasa2;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaTasaInteres');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async registraActualizaFechasMonedas(fecha1: any, fecha2: any) {
    const objPeticion: ClsPeticionFechaMonedas = new ClsPeticionFechaMonedas();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    // objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.FechaMoneda1 = fecha1;
    objPeticion.FechaMoneda2 = fecha2;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaFechasMonedas');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async guardarCostosMOOPCalculo(catalogo: ClsCatalogoCalculo[]) {
    const objPeticion: ClsPeticionCatalogoDetalleCostosRegistraActualiza2021 = new ClsPeticionCatalogoDetalleCostosRegistraActualiza2021();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.Catalogo = catalogo;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'CatalogoCostosCalculoRegistraActualiza2021');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async calcularPpto() {
    try {
      // se inicializan los parametros de la ventana de calculo
      this.mTipoExplosion = Number(this.componenteCalculo.radioTipoBusqueda);
      // this.mErrorPotenciales = this.componenteCalculo.errorPotencial.checked;
      this.mAsignarTasaIntCH = this.componenteCalculo.mismaTasa.checked;
      this.mTasa = Number(this.componenteCalculo.tasa.value);
      this.mAsignarFecha = this.componenteCalculo.asignarFecha.checked;
      this.mFechaAsignada = new Date(this.componenteCalculo.fechaAsignada.value);
      this.mTipoMonedaCalcular = Number(this.componenteCalculo.radioTipoBusquedaMoneda);
      // this.mFactorM1 = this.componenteCalculo.factorM1.value;
      // this.mFactorM2 = this.componenteCalculo.factorM2.value;
      this.mExplosionXConcepto = this.componenteCalculo.calExpInsXCon.checked;
      this.mExplotarInsumoCH = this.componenteCalculo.explotarInsCH.checked;
      this.mExplotarInsumosIntegrados = !this.componenteCalculo.noExplotarInsInt.checked;
      // Reutilizar el programa ya cargado al abrir la ventana (evita recargar en ClsObjCalculo)
      this.programaObra = this.componenteCalculo.programaObra;
      this.mProgSum = this.componenteCalculo.calProgSum.checked;
      this.mProgSumPar = this.componenteCalculo.calProgSumXPar.checked;

      await this.calcularPresupuesto();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async calcularPresupuesto() {
    let costo: number;
    let precio: number;
    this.mTotalCos = 0;
    this.mTotalPre = 0;
    this.mMapHCatalogo = new Map<bigint, ClsCalculoCatalogo>();
    this.mMapHMatriz = new Map<bigint, ClsCalculoMatriz[]>();
    this.mMapHPartidas = new Map<bigint, ClsCalculoPartidas>();
    this.mMapHPartidasDet = new Map<string, ClsConceptosPartidasGuardar>();
    this.mMapHTipos = new Map<number, number>();
    // this.mMapEsperaReserva = new Map<bigint, bigint>();
    this.mMapCostoHorariosCF = new Map<bigint, ClsCostoHorarios>();
    try {
      // Se mapea la exp de insumo para poder buscar rapido el idCatalogo
      this.mMapHExpInsumos = ClsUtil.crearMapIdCatalogo(this.infPpto.pptoActivoCompletoJSON.CatExpIns);
      this.mMapHCostoCalculo = ClsUtil.crearMapIdCatalogo(this.infPpto.pptoActivoCompletoJSON.CostosCalculo);
      // servicio asignar tasa de insteres a todos los CH dependiendo de la moneda
      if (this.mAsignarTasaIntCH) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.ASIGNAR_TASA_INT_MONEDA');
        await this.asignarMismaTasaInteres();
      }
      // metedo que obtiene todos los CH
      // this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.OBTENER_CH_CALCULO');
      // await this.mObjCostoHorario.obtenerTodosLosCH(0);
      this.mLCostoHorarios = this.infPpto.pptoActivoCompletoJSON.CostoHorarios;
      // metodo que obtiene todas las matrices del ppto
      // this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.OBTENER_MATRICES_CALCULO');
      // await this.mObjMatrices.obtenerTodasLasMatrices(0);
      this.mLMatrices = this.infPpto.pptoActivoCompletoJSON.Matrices;
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.DESCARGANDO_DOC');
      // descargar libros de costo horario y pie de indirecto
      await this.obtenerLibros();
      // obtener libro de pie de indirecto
      await this.obtenerParametrosPieIndirecto();
      // obtener libro de costo horario
      await this.obtenerParametrosCostoHorario();
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.VALIDANDO_INF');
      // metodo que llena el MapCatalogos, con inf de matrices y ppto(conceptos), partidas
      this.llenarMapas();
      // rutina para calcular los costos de obra publica (detalle de materiales) en caso de que tuvieran diferencias
      this.calcularCostoOP();
      // rutina que ajusta en caso de que haya diferencias en la tabla de mano de obra
      await this.calcularSalarios();
      // calcular matriz
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.CALCULAR_MATRICES');
      this.calcularMat();
      // calcular Precios Ppto
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.CALCULAR_PRECIOS_PPTO');
      this.calculaPreciosPresupuesto();
      // calular Exp Ins
      costo = this.mTotalCos;
      precio = this.mTotalPre;
      this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.PPTOCOSTOTOTAL).Valor = ClsUtil.esNulo(costo) ? '0' : costo.toString();
      this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.PPTOPRECIOTOTAL).Valor = ClsUtil.esNulo(precio) ? '0' : precio.toString();
      this.mMapHExplosion = new Map<bigint, number>();
      if (this.mTipoExplosion !== EnumTipoExpIns.NoCalcular) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.EXPLOTA_PPTO_CALCULO');
        this.explotaPresupuesto();
      }
      // grabar datos catalogo y partidas
      await this.guardarDatosCatPartidas();

      //  calcular exp por concepto
      this.mMapHExpXConcepto = new Map<bigint, ClsCalculoDetalleExpXConcepto[]>();
      if (this.mTipoExplosion === EnumTipoExpIns.DeTodoElPresupuesto) {
        if (this.mExplosionXConcepto) {
          this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.EXPLOTA_CONCEPTOS');
          this.explotaConceptos();
          //  grabar datos exp x concepto
          await this.guardarDatosExpXConeptos();
        }
        if (this.mProgSum) {
          this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.EXPLOTA_PROG_SUM');
          await this.ExplotaProgSum();
          await this.CalculaTotFinPre();
          //  grabar datos ExplotaProgSum y CalculaTotFinPre
          if (this.mUltimoResultadoProgSum.Detalle.length > 0) {
            this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.SAVE_PROG_SUM');
            const tab = ClsUtil.TAB;
            const enter = ClsUtil.ENTER;
            const detalle = this.mUltimoResultadoProgSum.Detalle;
            const buffer = new Array(detalle.length);

            for (let i = 0; i < detalle.length; i++) {
              const det = detalle[i];
              buffer[i] = `${det.IdCatalogo}${tab}${det.NumeroPeriodo}${tab}${det.Cantidad}`;
            }
            this.programaObra.JsonProgSum = buffer.join(enter) + enter;
            await this.mObjProgramacionObra.agregarModificarCatalogoPrograma([this.programaObra], 'ProgramasRegistraActualiza2021')
          }

          if (this.programaObra.LsPorcFinanciamiento.length > 0) {
            this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.SAVE_FIN_PROG_SUM');
            await this.mObjProgramacionObra.agregarModificarPorcentajesFinanciamiento(this.programaObra.LsPorcFinanciamiento, 'PorcentajesFinanciamientoRegistraActualiza');
          }
        }
        if (this.mProgSumPar) {
          this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.EXPLOTA_PROG_SUM_X_PARTIDA');
          await this.ExplotaPartidas();
          await this.ExplotaProgSumPar();
          //  grabar datos ExplotaPartidas y ExplotaProgSumPar
        }
      }
      // servicio asignar fecha a insumo, siempre y cuando tenga la marca
      if (this.mAsignarFecha) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.ASIGNAR_FECHA_MONEDA');
        await this.asignarFechaMoneda();
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Funcion que obtiene los libros de costo horario y pie de indirecto
   * @private
   */
  private async obtenerLibros() {
    const idppto: bigint = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    const paramLibros: ClsParametro[] = await this.mObjGenerico.obtenerNParametros(idppto, EnumTipoParametro.Presupuesto, this.mObjGenerico.mObjParamPpto.getParametrosLibros());

    // 🔥 helper para obtener parámetro rápido
    const getParam = (param: EnumParaPpto): string =>
      paramLibros.find(p => p.Parametro === param)?.Valor ?? '';

    const nombrePI: string = getParam(EnumParaPpto.SOBNOMBRELIBROPI1)
    const nombreCH: string = getParam(EnumParaPpto.CHNOMBRELIBROCH);

    const archivos: ClsArchivosEntrada = {
      CH: nombreCH,
      PI: nombrePI
    }

    const mapResp: Map<string, ClsListaArchivos> = await ClsUtil.inicializarListaDeDescargaArchivos(idppto, archivos, this.mObjGenerico);
    this.infPpto.docPieIndSelec1 = mapResp.get(EnumLibros.PI) ?? undefined;
    this.infPpto.docPieIndSelec2 = mapResp.get(EnumLibros.PI) ?? undefined;
    this.mLibroCostoHorario = mapResp.get(EnumLibros.CH);

  }

  private async obtenerParametrosPieIndirecto() {
    const idPpto: bigint = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    this.paramSobrecosto = await this.mObjGenerico.obtenerNParametros(idPpto, EnumTipoParametro.Presupuesto, this.mObjGenerico.mObjParamPpto.getParametrosCalSobrecosto());
    this.mValorSobrecosto = 0;
    this.mTieneLibroPieIndirecto = false;
    this.mTieneIndirecto = false;
    switch (this.mTipoMonedaCalcular) {
      case 0:
        if (!ClsUtil.esNulo(this.infPpto.docPieIndSelec1)) {
          this.mTieneLibroPieIndirecto = true;
          this.paramSobrecosto = this.paramSobrecosto.concat(await this.mObjGenerico.obtenerNParametros(idPpto, EnumTipoParametro.Presupuesto, this.mObjGenerico.mObjParamPpto.getParametrosCalLibroPIM1()));
          this.infPpto.docPieIndSelec1.Workbook = await ExcelUtility.load(this.infPpto.docPieIndSelec1.ContenidoArchivoFile);
        }
        if (!this.mTieneLibroPieIndirecto) {
          this.mValorSobrecosto = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.PPTOPORCSOBRECOSTO).Valor);
          this.mTieneIndirecto = !ClsUtil.esNulo(this.mValorSobrecosto);
        }
        break;
      case 1:
        if (!ClsUtil.esNulo(this.infPpto.docPieIndSelec2)) {
          this.mTieneLibroPieIndirecto = true;
          this.paramSobrecosto = this.paramSobrecosto.concat(await this.mObjGenerico.obtenerNParametros(idPpto, EnumTipoParametro.Presupuesto, this.mObjGenerico.mObjParamPpto.getParametrosCalLibroPIM1()));
          this.infPpto.docPieIndSelec2.Workbook = await ExcelUtility.load(this.infPpto.docPieIndSelec2.ContenidoArchivoFile);
        }
        if (!this.mTieneLibroPieIndirecto) {
          this.mValorSobrecosto = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBPORCENTAJESOBRECOSTO2).Valor);
          this.mTieneIndirecto = !ClsUtil.esNulo(this.mValorSobrecosto);
        }
        break;
      case 2:
        break;
    }
  }

  private async obtenerParametrosCostoHorario() {
    try {
      const idPpto: bigint = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
      const param: ClsParametro[] = await this.mObjGenerico.obtenerNParametros(idPpto, EnumTipoParametro.Presupuesto, this.mObjGenerico.mObjParamPpto.getParametrosCalCH());
      this.mLibroCostoHorario.Workbook = await this.mObjCostoHorario.validarSetIndexHojasCHDefault(this.mLibroCostoHorario.ContenidoArchivoFile);
      this.mHojaCamposGenerales = this.mLibroCostoHorario.Workbook.worksheets(this.mObjCostoHorario.IndiceHojaCamposGenerales);
      this.mHojaDatos = this.mLibroCostoHorario.Workbook.worksheets(this.mObjCostoHorario.IndiceHojaDatos);
      this.mHojaDatos.unprotect();
      this.mHojaCamposGenerales.unprotect();
      // decimales a redondear
      this.mHojaCamposGenerales.getCell('decimalesredondeo').value = this.infPpto.decimalredondearimporte;
      //  envia los % de espera y reserva
      this.mHojaDatos.getCell('DepreciacionE_Procentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHDEPRECIACIONE).Valor) / 100;
      this.mHojaDatos.getCell('DepreciacionR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHDEPRECIACIONR).Valor) / 100;
      this.mHojaDatos.getCell('InversionE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHINVERSIONE).Valor) / 100;
      this.mHojaDatos.getCell('InversionR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHINVERSIONR).Valor) / 100;
      this.mHojaDatos.getCell('SegurosE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHSEGUROSE).Valor) / 100;
      this.mHojaDatos.getCell('SegurosR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHSEGUROSR).Valor) / 100;
      this.mHojaDatos.getCell('MantenimientoE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHMANTENIMIENTOE).Valor) / 100;
      this.mHojaDatos.getCell('MantenimientoR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHMANTENIMIENTOR).Valor) / 100;
      this.mHojaDatos.getCell('CombustibleE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHCOMBUSTIBLEE).Valor) / 100;
      this.mHojaDatos.getCell('CombustibleR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHCOMBUSTIBLER).Valor) / 100;
      this.mHojaDatos.getCell('LubricanteE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHLUBRICANTESE).Valor) / 100;
      this.mHojaDatos.getCell('LubricanteR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHLUBRICANTESR).Valor) / 100;
      this.mHojaDatos.getCell('LlantasE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHLLANTASE).Valor) / 100;
      this.mHojaDatos.getCell('LlantasR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHLLANTASR).Valor) / 100;
      this.mHojaDatos.getCell('PiezasE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHPIEZAESPE).Valor);
      this.mHojaDatos.getCell('PiezasR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHPIEZAESPR).Valor) / 100;
      this.mHojaDatos.getCell('OperacionE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHOPERACIONE).Valor) / 100;
      this.mHojaDatos.getCell('OperacionR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHOPERACIONR).Valor) / 100;
      this.mHojaDatos.getCell('OtraFuentesE_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHOTRASFUENTESENERGIAE).Valor) / 100;
      this.mHojaDatos.getCell('OtraFuentesR_Porcentaje').value = Number(param.find(para => para.Parametro === EnumParaPpto.CHOTRASFUENTESENERGIAR).Valor) / 100;
      this.mHojaDatos.getCell('IndicadorEconomicoReferencia').value = param.find(para => para.Parametro === EnumParaPpto.CHINDREFERENCIA).Valor;
      this.mHojaDatos.getCell('IndicadorEspecificoMercado').value = param.find(para => para.Parametro === EnumParaPpto.CHINDESPECIFICOSEGUROS).Valor;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async guardarDatosCatPartidas() {
    let arrayCatalogoGuardar: ClsCalculoGuardarCatalogo[] = [];
    let arrayPartidasGuardar: ClsCalculoGuardarPartidas[] = [];
    let arrayCostosCalculo: ClsCatalogoCalculo[] = [];
    let arrayCostosMOCalculo: ClsCatalogoCalculo[] = [];
    let arrayCostosOPCalculo: ClsCatalogoCalculo[] = [];
    try {
      // generar datos para catalogo
      arrayCatalogoGuardar = this.generarDatosGuardarCatalogo();
      // generar datos para costos calculo
      arrayCostosCalculo = this.generarCostosCalculo();
      // generar datos para costos MO calculo
      arrayCostosMOCalculo = this.generarCostosMOCalculo();
      // generar datos para costos MAT calculo
      arrayCostosOPCalculo = this.generarCostosOPCalculo();
      // generar datos para partidas
      arrayPartidasGuardar = this.generarDatosGuardarPatidas();
      //  invocar servicio para catalogo
      if (arrayCatalogoGuardar.length > 0) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDAR_CATALOGO_CALCULO');
        await this.guardarCatalogo(arrayCatalogoGuardar);
      }
      //  invocar servicio para costos
      if (arrayCostosCalculo.length > 0) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDAR_COSTOS_CALCULO');
        await this.guardarCostosMOOPCalculo(arrayCostosCalculo);
      }
      //  invocar servicio para costos MO
      if (arrayCostosMOCalculo.length > 0) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDAR_COSTOS_MO_CALCULO');
        await this.guardarCostosMOOPCalculo(arrayCostosMOCalculo);
      }
      //  invocar servicio para costos MAT
      if (arrayCostosOPCalculo.length > 0) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDAR_COSTOS_OP_CALCULO');
        await this.guardarCostosMOOPCalculo(arrayCostosOPCalculo);
      }
      //  invocar servicio para partida
      if (arrayPartidasGuardar.length > 0) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDAR_PARTIDA_CALCULO');
        await this.guardarPartida(arrayPartidasGuardar);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async guardarDatosExpXConeptos() {
    const objPeticion: ClsPeticionExpinsXconcepto[] = [];
    try {
      this.mMapHExpXConcepto.forEach((value, key) => {
        const exp: ClsPeticionExpinsXconcepto = {IdCodigoMatriz: key, JsonExpinsXconcepto: value};
        objPeticion.push(exp);
      });
      if (objPeticion.length > 0) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDAR_EXP_X_CONCEPTOS');
        await this.guardarExpXConeptos(objPeticion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async asignarMismaTasaInteres() {
    let tasaM1: number;
    let tasaM2: number;
    try {
      switch (this.mTipoMonedaCalcular) {
        case 0:
          tasaM1 = this.mTasa;
          tasaM2 = 0;
          break;
        case 1:
          tasaM1 = 0;
          tasaM2 = this.mTasa;
          break;
      }
      await this.registraActualizaTasaInteresMonedas(tasaM1, tasaM2);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async asignarFechaMoneda() {
    let fecha1: any;
    let fecha2: any;
    try {
      switch (this.mTipoMonedaCalcular) {
        case 0:
          fecha1 = this.mFechaAsignada;
          fecha2 = '0001-01-01T00:00:00Z';
          break;
        case 1:
          fecha1 = '0001-01-01T00:00:00Z';
          fecha2 = this.mFechaAsignada;
          break;
        case 2:
          fecha1 = this.mFechaAsignada;
          fecha2 = this.mFechaAsignada;
          break;
      }
      await this.registraActualizaFechasMonedas(fecha1, fecha2);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Programa de suministros por periodo (VB `ExplotaProgSum`).
   *
   * Por cada número de periodo: llenar cantidades del periodo (`LlenaPerProgSum`), explotar matrices
   * (`CalculaExpins` → `calculaExpIns`), ajustar la mini-explosión al costo directo del periodo
   * (`ajustaExplosionG` → `ajustarExplosion`), y acumular el detalle por insumo.
   * Al terminar todos los periodos: `ajustaProgSum` para alinear sumas con `Expins` del catálogo.
   */
  private async ExplotaProgSum(): Promise<void> {
    const periodos = ClsUtil.numberX(this.programaObra.NoPeriodos);
    const explosionAntes = new Map(this.mMapHExplosion);
    const mapaPct = this.obtenerMapaPorcentajesPorControlProgSum();
    const capturarPorcentaje = !!this.programaObra.CapturarPorcentaje;
    const detalle: IProgSumExplosionDetalle[] = [];
    this.mMapCostoPrecioPeriodo = new Map<number, IProgSumExplosionDetalle>();
    try {
      for (let numeroPeriodo = 1; numeroPeriodo <= periodos; numeroPeriodo++) {
        const {
          totalCostoDirectoPeriodo,
          totalPrecioVentaPeriodo
        } = this.LlenaPerProgSum(numeroPeriodo, mapaPct, capturarPorcentaje);
        this.mMapCostoPrecioPeriodo.set(numeroPeriodo, {
          Costo: totalCostoDirectoPeriodo,
          Precio: totalPrecioVentaPeriodo
        });
        this.calculaExpIns();
        this.ajustarExplosion(totalCostoDirectoPeriodo, this.infPpto.decimalredondearexpins);
        this.acumularDetalleProgSumPeriodo(numeroPeriodo, detalle);
      }
      this.ajustaProgSum(detalle);
      // filtramos solo los que sean distinto a 0
      const filtrado = detalle.filter((d) => ClsUtil.numberX(d.Cantidad) !== 0);
      this.mUltimoResultadoProgSum = new ClsDtoResultadoProgSumExplosion();
      this.mUltimoResultadoProgSum.IdPresupuesto = ClsUtil.cadenaX(this.infPpto.pptoSeleccionadoActivo.IdPresupuesto);
      this.mUltimoResultadoProgSum.IdPrograma = ClsUtil.cadenaX(this.programaObra.IdPrograma);
      this.mUltimoResultadoProgSum.FechaUtc = new Date().toISOString();
      this.mUltimoResultadoProgSum.Detalle = filtrado;
    } finally {
      this.mMapHExplosion = explosionAntes;
    }
  }

  /**
   * Por cada concepto (`Control`), valores por número de periodo: porcentaje o cantidad según `CapturarPorcentaje`
   * (equivalente a `PuProgramaConceptosPeriodos.Porcentaje` en VB).
   *
   * Fuentes: JSON opcional `JsonDetallePorcentajes` y el último campo de cada línea de `JsonDetallePrograma`
   * (`NumeroPeriodo,Valor;…`). Si un concepto aparece en ambos, se fusionan periodo a periodo.
   */
  private obtenerMapaPorcentajesPorControlProgSum(): Map<number, Map<number, number>> {
    const out = new Map<number, Map<number, number>>();

    let detProg = this.programaObra?.JsonDetallePrograma;
    detProg = ClsUtil.cadenaX(detProg); // validamos si es null o undefined se de asigna valor ''
    if (detProg.trim() !== '') {
      const lineas = detProg.split('\n').filter((l) => l.trim() !== '');
      for (const linea of lineas) {
        const campos = linea.split('\t');
        if (campos.length < 14) {
          continue;
        }

        const control = ClsUtil.numberX(campos[0]);
        if (ClsUtil.esNulo(control)) {
          continue;
        }

        const jsonPorcentajes = ClsUtil.cadenaX(campos[13]).trim();
        if (jsonPorcentajes === '') {
          continue;
        }

        const inner = out.get(control) ?? new Map<number, number>();
        const items = jsonPorcentajes.split(';').filter((x) => x.trim() !== '');

        for (let j = 0; j < items.length; j++) {
          const item = items[j];
          if (ClsUtil.esNulo(item)) {
            continue;
          }

          const [num, val] = item.split(',');
          const n = ClsUtil.numberX(num);
          const v = ClsUtil.numberX(val);
          inner.set(n, v);
        }
        out.set(control, inner);
      }
    }
    return out;
  }

  /**
   * VB `LlenaPerProgSum`: vacía la hash de explosión, reparte cantidades del periodo por concepto del programa
   * y acumula `TotalPeriodo` = suma de `Redondea(Cantidad * Costo, mDecimales)` (costo directo del periodo).
   *
   * `Cantidad` del periodo: si `CapturarPorcentaje`, `CantidadTotal * Porcentaje / 100`; si no, el valor del periodo es la cantidad.
   * Costo y precio unitario del concepto: equivalente a `PuExpInsCostos` + `PuPresupuestosConceptosPrecios` (`mMapHCatalogo` + precio del concepto).
   */
  private LlenaPerProgSum(numeroPeriodo: number, mapaPct: Map<number, Map<number, number>>, capturarPorcentaje: boolean): {
    totalCostoDirectoPeriodo: number;
    totalPrecioVentaPeriodo: number
  } {
    this.mMapHExplosion.clear();
    let totalCostoDirectoPeriodo = 0;
    let totalPrecioVentaPeriodo = 0;
    const decimalesImporte = this.infPpto.decimalredondearimporte;
    const decimalesCantidad = this.infPpto.decimalredondearcantidad;
    const pres = [...(this.infPpto.pptoActivoCompletoJSON.Presupuesto ?? [])].sort(
      (a, b) => (ClsUtil.numberX(a.CostoMoneda1) ?? 0) - (ClsUtil.numberX(b.CostoMoneda1) ?? 0)
    );
    for (const pptoCon of pres) {
      const control = ClsUtil.numberX(pptoCon.Control);
      if (ClsUtil.esNulo(control)) continue;
      const porPeriodo = mapaPct.get(control);
      if (!porPeriodo || porPeriodo.size === 0) continue;

      const valorPeriodo = porPeriodo.has(numeroPeriodo) ? ClsUtil.numberX(porPeriodo.get(numeroPeriodo)) ?? 0 : 0;

      const idCatalogoConcepto = ClsUtil.bigintX(pptoCon.IdCatalogo);
      const cantidadTotal = ClsUtil.redondear(pptoCon.Cantidad, decimalesCantidad);
      const valor: number = ClsUtil.redondearMoneda(valorPeriodo / 100, decimalesCantidad);
      const cantidadEnPeriodo = capturarPorcentaje
        ? ClsUtil.redondearMoneda(cantidadTotal * valor, decimalesCantidad)
        : valor;

      let costoUnitario = 0;
      let precioUnitarioConcepto = 0;
      switch (this.mTipoMonedaCalcular) {
        case 0:
          costoUnitario = ClsUtil.numberX(pptoCon.CostoMoneda1) ?? 0;
          precioUnitarioConcepto = ClsUtil.numberX(pptoCon.PrecioMoneda1) ?? 0;
          break;
        case 1:
          costoUnitario = ClsUtil.numberX(pptoCon.CostoMoneda2) ?? 0;
          precioUnitarioConcepto = ClsUtil.numberX(pptoCon.PrecioMoneda2) ?? 0;
          break;
        default:
          break;
      }
      const importeCosto = ClsUtil.redondearMoneda(cantidadEnPeriodo * costoUnitario, decimalesImporte);
      const importePrecio = ClsUtil.redondearMoneda(cantidadEnPeriodo * precioUnitarioConcepto, decimalesImporte);
      totalCostoDirectoPeriodo = ClsUtil.redondearMoneda(totalCostoDirectoPeriodo + importeCosto, decimalesImporte);
      totalPrecioVentaPeriodo = ClsUtil.redondearMoneda(totalPrecioVentaPeriodo + importePrecio, decimalesImporte);
      this.sumaCantidad(idCatalogoConcepto, cantidadEnPeriodo);
    }
    return {totalCostoDirectoPeriodo, totalPrecioVentaPeriodo};
  }

  private llenaPerProgSumPar(idPresupuestoPartida: bigint, numeroPeriodo: number, mapaPct: Map<number, Map<number, number>>, capturarPorcentaje: boolean): {
    totalPartida: number
  } {
    this.mMapHExplosion.clear();
    let totalPartida = 0;
    const decimalesCantidad = this.infPpto.decimalredondearcantidad;
    const decimalesImporte = this.infPpto.decimalredondearimporte;
    const conceptosPartida = this.mMergePresupuestoConcentosPorPartida.get(idPresupuestoPartida);
    if (!conceptosPartida) {
      for (const [control, value] of conceptosPartida) {
        if (ClsUtil.esNulo(control)) continue;
        const porPeriodo = mapaPct.get(control);
        if (!porPeriodo || porPeriodo.size === 0) continue;

        const valorPeriodo = porPeriodo.has(numeroPeriodo)
          ? ClsUtil.numberX(porPeriodo.get(numeroPeriodo)) ?? 0
          : 0;

        const idCatalogoConcepto = ClsUtil.bigintX(value.IdCatalogo);
        const cantidadTotal = ClsUtil.redondear(value.Cantidad, decimalesCantidad);
        const costoTotal = ClsUtil.redondear(value.Costo, decimalesImporte);

        const valor = ClsUtil.redondearMoneda(valorPeriodo / 100, decimalesCantidad);

        const cantidadEnPeriodo = capturarPorcentaje
          ? ClsUtil.redondearMoneda(cantidadTotal * valor, decimalesCantidad)
          : valor;

        const importeCosto = ClsUtil.redondearMoneda(cantidadEnPeriodo * costoTotal, decimalesImporte);
        totalPartida = ClsUtil.redondearMoneda(totalPartida + importeCosto, decimalesImporte);
        this.sumaCantidad(idCatalogoConcepto, cantidadEnPeriodo);
      }
    }
    return {totalPartida};
  }

  /**
   * Tras `ajustarExplosion`, vuelca al detalle las filas que en VB escribe `escribeProgSumExplosionDetalle`
   * (solo insumos con `CalculaExpinsL` = 1). `Costo` y `Precio` son importes del periodo para el insumo explotado.
   */
  private acumularDetalleProgSumPeriodo(numeroPeriodo: number, detalle: IProgSumExplosionDetalle[]): void {
    const mapExplosion = this.mMapHExplosion;
    const mapCatalogo = this.mMapHCatalogo;
    const calculaExpinsL = this.calculaExpinsL;
    const decimalesExplosion = this.infPpto.decimalredondearexpins;

    for (const [idCatalogo, cantidadSinRedondear] of mapExplosion) {
      if (cantidadSinRedondear <= 0) continue;

      const catalogo = mapCatalogo.get(idCatalogo);
      if (!catalogo) continue;

      if (calculaExpinsL.call(this, catalogo) !== 1) continue;

      const cantidadPeriodo = ClsUtil.redondear(cantidadSinRedondear, decimalesExplosion);
      const {costoUnitario, precioUnitarioVenta} = this.costoPrecioUnitarioInsumoProgSum(idCatalogo, catalogo);
      const decimalesImporte = this.infPpto.decimalredondearimporte;
      const importeCostoPeriodo = ClsUtil.redondearMoneda(cantidadPeriodo * costoUnitario, decimalesImporte);
      const importePrecioPeriodo = ClsUtil.redondearMoneda(cantidadPeriodo * precioUnitarioVenta, decimalesImporte);
      detalle.push({
        IdCatalogo: ClsUtil.cadenaX(idCatalogo),
        NumeroPeriodo: numeroPeriodo,
        Cantidad: cantidadPeriodo,
        Costo: importeCostoPeriodo,
        Precio: importePrecioPeriodo
      });
    }
  }

  private acumularDetalleProgSumParPeriodo(idPresupuestoPartida: bigint, detalle: IProgSumExplosionDetalle[], numeroPeriodo: number, decimalesExplosion: number) {
    const mapExplosion = this.mMapHExplosion;
    const mapCatalogo = this.mMapHCatalogo;
    const calculaExpinsL = this.calculaExpinsL;

    for (const [idCatalogo, cantidadSinRedondear] of mapExplosion) {
      if (cantidadSinRedondear <= 0) continue;

      const catalogo = mapCatalogo.get(idCatalogo);
      if (!catalogo) continue;

      if (calculaExpinsL.call(this, catalogo) !== 1) continue;

      const cantidadPeriodo = ClsUtil.redondear(cantidadSinRedondear, decimalesExplosion);
      detalle.push({
        IdCatalogo: ClsUtil.cadenaX(idCatalogo),
        NumeroPeriodo: numeroPeriodo,
        Cantidad: cantidadPeriodo,
      });
    }
    this.mPresupuestoConcentosPorPartida.set(idPresupuestoPartida, detalle);
  }

  /**
   * Costo unitario coherente con `ajustarExplosion` / VB `DatosCatalogo.Costo` en la mini-explosión.
   *
   * Precio unitario de venta: en VB no se guarda por insumo en `PuProgramaSum`; aquí se deriva del catálogo explotado
   * (`ImporteMoneda / Expins` cuando `Expins > 0`) para repartir el importe de venta del insumo.
   */
  private costoPrecioUnitarioInsumoProgSum(idCatalogo: bigint, catalogoCalculo: ClsCalculoCatalogo): {
    costoUnitario: number;
    precioUnitarioVenta: number
  } {
    const esMoneda1 = this.mTipoMonedaCalcular === 0;
    // ✅ costo unitario
    const costoUnitario = esMoneda1 ? catalogoCalculo.CostoMoneda1 : catalogoCalculo.CostoMoneda2;

    const exp = this.mMapHExpInsumos.get(idCatalogo);
    // ✅ salida rápida (early return)
    if (!exp || exp.Expins <= 0) {
      return {costoUnitario, precioUnitarioVenta: 0};
    }

    // ✅ cálculo directo
    const importe = esMoneda1 ? exp.ImporteMoneda1 : exp.ImporteMoneda2;

    const precioUnitarioVenta = importe / exp.Expins;

    return {costoUnitario, precioUnitarioVenta};
  }

  /**
   * VB `ajustaProgSum`: por cada `IdExpIns` ordenado, si la suma de cantidades por periodo es cercana a `Expins`
   * del catálogo, se corrige la diferencia en el primer periodo que lo admita (`AjustaProgSumDet`).
   *
   * Si `JsonProgSum` trae filas, solo se consideran insumos cuyo `IdCatalogo` aparece ahí (misma clave que en el JSON).
   */
  private ajustaProgSum(detalle: IProgSumExplosionDetalle[]): void {
    const filasProgSum = this.parseJsonProgSumSeguro(this.programaObra?.JsonProgSum);
    const idsCatalogoPermitidos = filasProgSum.length > 0 ? new Set(filasProgSum.map((r) => ClsUtil.cadenaX(r.IdCatalogo))) : null;

    type ReferenciaFilaDetalle = { indice: number; cantidad: number };
    const filasPorCatalogo = new Map<string, ReferenciaFilaDetalle[]>();

    detalle.forEach((fila, indice) => {
      if (idsCatalogoPermitidos && !idsCatalogoPermitidos.has(String(fila.IdCatalogo))) {
        return;
      }
      const clave = String(fila.IdCatalogo);
      if (!filasPorCatalogo.has(clave)) {
        filasPorCatalogo.set(clave, []);
      }
      filasPorCatalogo.get(clave).push({indice, cantidad: ClsUtil.numberX(fila.Cantidad) ?? 0});
    });

    const idsOrdenados = [...filasPorCatalogo.keys()].sort((a, b) => {
      try {
        const ba = BigInt(a);
        const bb = BigInt(b);
        return ba < bb ? -1 : ba > bb ? 1 : 0;
      } catch {
        return a.localeCompare(b);
      }
    });
    for (const idCatalogoStr of idsOrdenados) {
      const referencias = filasPorCatalogo
        .get(idCatalogoStr)
        .slice()
        .sort((x, y) => detalle[x.indice].NumeroPeriodo - detalle[y.indice].NumeroPeriodo);
      const sumaCantidadesPeriodos = referencias.reduce((acum, r) => acum + r.cantidad, 0);
      const idCatalogo = ClsUtil.bigintX(idCatalogoStr);
      let cantidadTotalExplotada = 0;
      if (this.mMapHExpInsumos.has(idCatalogo)) {
        cantidadTotalExplotada = ClsUtil.numberX(this.mMapHExpInsumos.get(idCatalogo).Expins) ?? 0;
      } else if (this.mMapHCatalogo.has(idCatalogo)) {
        cantidadTotalExplotada = ClsUtil.numberX(this.mMapHCatalogo.get(idCatalogo).Expins) ?? 0;
      }
      this.AjustaProgSumDet(sumaCantidadesPeriodos, referencias, detalle, cantidadTotalExplotada);
    }
  }

  private ajustaProgSumPar() {

  }

  /** VB `AjustaProgSumDet`: solo ajusta si `Expins/Suma` está entre 0,9 y 1,1 (margen ~10 %). */
  private AjustaProgSumDet(sumaCantidadesPeriodos: number, referencias: {
    indice: number;
    cantidad: number
  }[], detalle: IProgSumExplosionDetalle[], cantidadTotalExplotada: number): void {
    if (sumaCantidadesPeriodos === 0) {
      return;
    }
    const decimalesCant = this.infPpto.decimalredondearcantidad;
    let diferencia: number;

    diferencia = ClsUtil.redondear(cantidadTotalExplotada / sumaCantidadesPeriodos, decimalesCant);
    if (diferencia > 0.9 && diferencia < 1.1) {
      diferencia = ClsUtil.redondear(cantidadTotalExplotada - sumaCantidadesPeriodos, decimalesCant);
      if (diferencia !== 0) {
        const decimalesExplosion = this.infPpto.decimalredondearexpins;
        for (const ref of referencias) {
          const cantidadAjustada = ClsUtil.redondear(ref.cantidad + diferencia, decimalesCant);
          if (cantidadAjustada > 0) {
            const fila = detalle[ref.indice];
            fila.Cantidad = ClsUtil.redondear(cantidadAjustada, decimalesExplosion);
            /** Recalcula `Costo` y `Precio` (importes) de una fila tras cambiar la cantidad. */
            this.recalcularImportesDetalleProgSum(fila);
            break;
          }
        }
      }
    }
  }

  /** Recalcula `Costo` y `Precio` (importes) de una fila tras cambiar la cantidad. */
  private recalcularImportesDetalleProgSum(fila: IProgSumExplosionDetalle): void {
    const idCatalogo = ClsUtil.bigintX(fila.IdCatalogo);
    const catalogo = this.mMapHCatalogo.get(idCatalogo);
    if (!catalogo) {
      return;
    }
    const cantidad = ClsUtil.numberX(fila.Cantidad) ?? 0;
    const {costoUnitario, precioUnitarioVenta} = this.costoPrecioUnitarioInsumoProgSum(idCatalogo, catalogo);
    const decimalesImporte = this.infPpto.decimalredondearimporte;
    fila.Costo = ClsUtil.redondearMoneda(cantidad * costoUnitario, decimalesImporte);
    fila.Precio = ClsUtil.redondearMoneda(cantidad * precioUnitarioVenta, decimalesImporte);
  }

  private parseJsonProgSumSeguro(raw: string | null | undefined): IJsonProgSumItem[] {
    if (raw == null || String(raw).trim() === '') {
      return [];
    }
    try {
      const v = JSON.parse(String(raw));
      if (!Array.isArray(v)) {
        return [];
      }
      const out: IJsonProgSumItem[] = [];
      for (const x of v) {
        if (x == null || typeof x !== 'object') {
          continue;
        }
        out.push({
          IdCatalogo: (x as IJsonProgSumItem).IdCatalogo,
          NumeroPeriodo: ClsUtil.numberX((x as IJsonProgSumItem).NumeroPeriodo) ?? 0,
          Cantidad: ClsUtil.numberX((x as IJsonProgSumItem).Cantidad) ?? 0
        });
      }
      return out;
    } catch {
      return [];
    }
  }

  /** VB `AjustaArreglo`: si la suma del arreglo difiere de `totalBuscado` en ≤0.5 %, ajusta el último periodo con importe positivo. */
  private ajustaArregloTotFin(totalBuscado: number, arreglo: number[], dec: number): void {
    if (arreglo.length === 0) {
      return;
    }
    let totalActual = 0;
    for (let i = 0; i < arreglo.length; i++) {
      totalActual += arreglo[i];
    }
    totalActual = ClsUtil.redondearMoneda(totalActual, dec);
    const diferencia = ClsUtil.redondearMoneda(totalBuscado - totalActual, dec);
    if (diferencia === 0) {
      return;
    }
    const dif = ClsUtil.redondearMoneda(diferencia / totalBuscado, dec);
    if (ClsUtil.redondearMoneda(dif * 100, dec) > 0.5) {
      return;
    }
    for (let i = arreglo.length - 1; i >= 0; i--) {
      if (arreglo[i] + diferencia > 0 && arreglo[i] > 0) {
        arreglo[i] = ClsUtil.redondearMoneda(arreglo[i] + diferencia, dec);
        break;
      }
    }
  }

  /**
   * Totales MA/MO/EQ/Otros desde la explosión en memoria (VB `EscribeDatosExplosion` + mismas reglas que `ajustarExplosion`).
   * Sirven como `mTotalCosMA`… para alinear periodos con `AjustaArreglo` tras `CalculaTotFinSum`.
   */
  private totalesFinanciamientoExplosionPorTipo(dec: number): {
    totalMA: number;
    totalMO: number;
    totalEQ: number;
    totalOtros: number;
  } {
    let totalMA = 0;
    let totalMO = 0;
    let totalEQ = 0;
    let totalOtros = 0;
    const decExp = this.infPpto.decimalredondearexpins;
    if (!this.mMapHExplosion || this.mMapHExplosion.size === 0) {
      return {totalMA, totalMO, totalEQ, totalOtros};
    }
    this.mMapHExplosion.forEach((cantRaw, clave) => {
      const datosCatalogo = this.mMapHCatalogo.get(clave);
      if (!datosCatalogo) {
        return;
      }
      if (this.calculaExpinsL(datosCatalogo) !== 1) {
        return;
      }
      const valor = ClsUtil.redondear(cantRaw, decExp);
      let importe: number;
      if (!datosCatalogo.EsPorcentaje) {
        let costoU = 0;
        switch (this.mTipoMonedaCalcular) {
          case 0:
            costoU = datosCatalogo.CostoMoneda1;
            break;
          case 1:
            costoU = datosCatalogo.CostoMoneda2;
            break;
          case 2:
            costoU = datosCatalogo.CostoMoneda3;
            break;
          default:
            costoU = datosCatalogo.CostoMoneda1;
            break;
        }
        importe = ClsUtil.redondearMoneda(valor * costoU, dec);
      } else {
        importe = ClsUtil.redondearMoneda(valor, dec);
      }
      switch (datosCatalogo.TipoInsumo) {
        case 1:
          totalMA = ClsUtil.redondearMoneda(totalMA + importe, dec);
          break;
        case 2:
          totalMO = ClsUtil.redondearMoneda(totalMO + importe, dec);
          break;
        case 3:
          totalEQ = ClsUtil.redondearMoneda(totalEQ + importe, dec);
          break;
        default:
          totalOtros = ClsUtil.redondearMoneda(totalOtros + importe, dec);
          break;
      }
    });
    return {totalMA, totalMO, totalEQ, totalOtros};
  }

  /**
   * CalculaTotFinPre: totales por periodo para financiamiento (VB `CalculaTotFinPre` + `CalculaTotFinSum`).
   * Agrupa `mUltimoResultadoProgSum` por periodo y tipo de insumo (`ClsCalculoCatalogo.TipoInsumo` ≡ `IdTipo`),
   * aplica `AjustaArreglo` por tipo (MA/MO/EQ/Otros) frente a explosión, luego costo/precio frente a `mTotalCos` y `mTotalPre`
   * (VB `AjustaArreglo(mTotalCos, mArregloCostoTotFin)` / `AjustaArreglo(mTotalPre, mArregloPrecioTotFin)`), y rellena `programaObra.LsPorcFinanciamiento`
   * con `JsonPorcentajesFM` (18 campos por moneda; bloque activo según `mTipoMonedaCalcular`).
   */
  private async CalculaTotFinPre(): Promise<void> {
    const prog = this.programaObra;
    const numPeriodos = ClsUtil.numberX(prog.NoPeriodos);
    const mapPorcFinan = new Map<number, ClsPorcentajesFinanciamiento>();
    const arr = prog.LsPorcFinanciamiento;
    for (let i = 0; i < arr.length; i++) {
      const value = arr[i];
      mapPorcFinan.set(value.NoPeriodo, value);
    }
    prog.LsPorcFinanciamiento = [];

    const idPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    const idPrograma = prog.IdPrograma;
    const dec = this.infPpto.decimalredondearimporte;
    const tab = ClsUtil.TAB;

    const tipoMoneda = this.mTipoMonedaCalcular;
    const ceroStr = String(ClsUtil.redondearMoneda(0, dec));

    type BucketProg = { MA: number; MO: number; EQ: number; OTROS: number; Costo: number, Precio: number };
    const porPeriodo = new Map<number, BucketProg>();

    const detalle = this.mUltimoResultadoProgSum?.Detalle;
    const nDet = detalle ? detalle.length : 0;
    for (let i = 0; i < nDet; i++) {
      const r = detalle[i];
      const periodo = ClsUtil.numberX(r.NumeroPeriodo) ?? 0;

      if (periodo < 1 || periodo > numPeriodos) continue;

      const costo = ClsUtil.numberX(r.Costo) ?? 0;

      let b = porPeriodo.get(periodo);
      if (!b) {
        b = {MA: 0, MO: 0, EQ: 0, OTROS: 0, Costo: 0, Precio: 0};
        porPeriodo.set(periodo, b);
      }

      const idCat = ClsUtil.bigintX(r.IdCatalogo);
      const cat = this.mMapHCatalogo.get(idCat);
      const tipo = cat ? cat.TipoInsumo : -1;
      switch (tipo) {
        case 1:
          b.MA = ClsUtil.redondearMoneda(b.MA + costo, dec);
          break;
        case 2:
          b.MO = ClsUtil.redondearMoneda(b.MO + costo, dec);
          break;
        case 3:
          b.EQ = ClsUtil.redondearMoneda(b.EQ + costo, dec);
          break
        default:
          b.OTROS = ClsUtil.redondearMoneda(b.OTROS + costo, dec);
      }
    }

    const arrMA: number[] = [];
    const arrMO: number[] = [];
    const arrEQ: number[] = [];
    const arrOt: number[] = [];
    for (let p = 1; p <= numPeriodos; p++) {
      const buck = porPeriodo.get(p);
      arrMA.push(ClsUtil.redondearMoneda(buck?.MA ?? 0, dec));
      arrMO.push(ClsUtil.redondearMoneda(buck?.MO ?? 0, dec));
      arrEQ.push(ClsUtil.redondearMoneda(buck?.EQ ?? 0, dec));
      arrOt.push(ClsUtil.redondearMoneda(buck?.OTROS ?? 0, dec));
    }

    const {totalMA, totalMO, totalEQ, totalOtros} = this.totalesFinanciamientoExplosionPorTipo(dec);
    this.ajustaArregloTotFin(totalMA, arrMA, dec);
    this.ajustaArregloTotFin(totalMO, arrMO, dec);
    this.ajustaArregloTotFin(totalEQ, arrEQ, dec);
    this.ajustaArregloTotFin(totalOtros, arrOt, dec);

    const arrCosto: number[] = [];
    const arrPrecio: number[] = [];
    const mapCosto = this.mMapCostoPrecioPeriodo;
    for (let p = 1; p <= numPeriodos; p++) {
      const buck = mapCosto.get(p);
      arrCosto.push(ClsUtil.redondearMoneda(buck?.Costo ?? 0, dec));
      arrPrecio.push(ClsUtil.redondearMoneda(buck?.Precio ?? 0, dec));
    }
    this.ajustaArregloTotFin(this.mTotalCos, arrCosto, dec);
    this.ajustaArregloTotFin(this.mTotalPre, arrPrecio, dec);

    const out: ClsPorcentajesFinanciamiento[] = [];
    for (let noPeriodo = 1; noPeriodo <= numPeriodos; noPeriodo++) {
      const idx = noPeriodo - 1;
      const valores = [arrCosto[idx], arrPrecio[idx], arrMA[idx], arrMO[idx], arrEQ[idx], arrOt[idx]];

      const blkVals = valores.join(tab);
      const blkCeros = Array(6).fill(ceroStr).join(tab);

      let jsonPorcentajesFM: string;
      switch (tipoMoneda) {
        case 0:
          jsonPorcentajesFM = `${blkVals}${tab}${blkCeros}${tab}${blkCeros}`;
          break;
        case 1:
          jsonPorcentajesFM = `${blkCeros}${tab}${blkVals}${tab}${blkCeros}`;
          break;
        case 2:
          jsonPorcentajesFM = `${blkCeros}${tab}${blkCeros}${tab}${blkVals}`;
          break;
        default:
          jsonPorcentajesFM = `${blkVals}${tab}${blkCeros}${tab}${blkCeros}`;
          break;
      }

      const fila = new ClsPorcentajesFinanciamiento();
      fila.IdPresupuesto = idPresupuesto;
      fila.IdPrograma = idPrograma;
      fila.IdPorcentajeFinanciamiento = mapPorcFinan.get(noPeriodo)?.IdPorcentajeFinanciamiento ?? BigInt(0);
      fila.NoPeriodo = noPeriodo;
      fila.JsonPorcentajesFM = jsonPorcentajesFM;
      out.push(fila);
    }
    prog.LsPorcFinanciamiento = out;
  }

  /**
   * ExplotaPartidas: explosión de insumos x partida (PuExpinsPar).
   */
  private async ExplotaPartidas(): Promise<void> {
    const explosionAntes = new Map(this.mMapHExplosion);
    try {
      this.explotaConceptos();
      const result = ClsUtil.mergePresupuestoMatrices(this.infPpto.pptoActivoCompletoJSON, this.infPpto, this.mMapHExpXConcepto, this.mTipoMonedaCalcular);
      this.mMergePresupuestoMatricesPorPartida = result.mapEncabezado;
      this.mMergePresupuestoConcentosPorPartida = result.mapEncabezado2;
      const presupuesto = this.infPpto.pptoActivoCompletoJSON.Presupuesto;
      const decImp = this.infPpto.decimalredondearimporte;
      const decExp = this.infPpto.decimalredondearexpins;
      const esMoneda1 = this.mTipoMonedaCalcular === 0;
      this.mMapHExplosion.clear();
      this.mMapHExpXPartida.clear();

      const filas: ClsConceptosPartida[] = [...presupuesto].sort((a, b) => a.Partida.localeCompare(b.Partida));

      let tIdPartida = BigInt(0);
      let totalPartida = 0;

      const costoConcepto = (c: ClsConceptosPartida): number => {
        return esMoneda1 ? c.CostoMoneda1 : c.CostoMoneda2;
      };

      const volcarPartida = (idPartida: bigint): void => {
        this.calculaExpIns();
        this.ajustarExplosion(totalPartida, decExp);
        this.escribeExpinsParMemoria(idPartida);
        this.mMapHExplosion.clear();
      };

      for (let i = 0; i < filas.length; i++) {
        const fila = filas[i];
        const idPartida = ClsUtil.bigintX(fila.IdPresupuestoPartida ?? 0);
        const claveInsumo = ClsUtil.bigintX(fila.IdCatalogo);
        const cantidad = fila.Cantidad;
        const costo = costoConcepto(fila);
        if (tIdPartida !== idPartida) {
          if (tIdPartida > BigInt(0)) {
            volcarPartida(tIdPartida);
          }
          tIdPartida = idPartida;
          totalPartida = 0;
        }
        totalPartida = ClsUtil.redondearMoneda(totalPartida + ClsUtil.redondearMoneda(cantidad * costo, decImp), decImp);
        this.sumaCantidad(claveInsumo, cantidad);
      }
      if (tIdPartida > BigInt(0)) {
        volcarPartida(tIdPartida);
      }
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.mMapHExplosion = explosionAntes;
    }
  }

  /** Equivalente a VB `EscribeExpinsPar`: solo insumos con `CalculaExpinsL` = 1, en memoria. */
  private escribeExpinsParMemoria(idPresupuestoPartida: bigint): void {
    const det = new Map<bigint, number>();
    this.mMapHExplosion.forEach((cantidad, clave) => {
      if (cantidad <= 0) {
        return;
      }
      const datosCatalogo = this.mMapHCatalogo.get(clave);
      if (!datosCatalogo) {
        return;
      }
      if (this.calculaExpinsL(datosCatalogo) !== 1) {
        return;
      }
      det.set(clave, cantidad);
    });
    this.mMapHExpXPartida.set(idPresupuestoPartida, det);
  }

  /**
   * ExplotaProgSumPar: programa de suministros por partida y por periodo (PuProgramaSumXPar).
   */
  private async ExplotaProgSumPar(): Promise<void> {
    const explosionAntes = new Map(this.mMapHExplosion);
    const numPeriodos = ClsUtil.numberX(this.programaObra.NoPeriodos);
    const decExp = this.infPpto.decimalredondearexpins;
    const mapaPct = this.obtenerMapaPorcentajesPorControlProgSum();
    const capturarPorcentaje = !!this.programaObra.CapturarPorcentaje;
    this.mPresupuestoConcentosPorPartida = new Map<bigint, IProgSumExplosionDetalle[]>();
    const detalle: IProgSumExplosionDetalle[] = [];
    try {
      this.mMergePresupuestoMatricesPorPartida.forEach((presupuesto, idPresupuestoPartida) => {
        for (let p = 1; p <= numPeriodos; p++) {
          const {totalPartida} = this.llenaPerProgSumPar(idPresupuestoPartida, p, mapaPct, capturarPorcentaje);
          this.calculaExpIns();
          this.ajustarExplosion(totalPartida, decExp)
          this.acumularDetalleProgSumParPeriodo(idPresupuestoPartida, detalle, p, decExp)
        }
      })
      this.ajustaProgSumPar();
    } finally {
      this.mMapHExplosion = explosionAntes;
    }
  }

  private generarDatosGuardarCatalogo(): ClsCalculoGuardarCatalogo[] {
    const arrayCatalogoGuardar: ClsCalculoGuardarCatalogo[] = [];
    let cambioCatalogo: boolean;
    let cambioExpIns: boolean;
    let datosCatalogo: ClsCalculoCatalogo;
    let tExpinsl: boolean;
    try {
      this.infPpto.pptoActivoCompletoJSON.CatExpIns.forEach(valueOriginal => {
        const llave: bigint = ClsUtil.bigintX(valueOriginal.IdCatalogo);
        cambioCatalogo = false;
        cambioExpIns = false;
        tExpinsl = false;
        if (this.mMapHCatalogo.has(llave)) {
          datosCatalogo = this.mMapHCatalogo.get(llave);
          // if (datosCatalogo.TchFij === EnumTipoTchFij.CargoFijo) {
          //   datosCatalogo.Nivel = 0;
          // }
          if (datosCatalogo.Nivel !== valueOriginal.Nivel || datosCatalogo.CostoMoneda1 !== valueOriginal.CostoMoneda1 || datosCatalogo.CostoMoneda2 !== valueOriginal.CostoMoneda2) {
            cambioCatalogo = true;
          }
          if (this.mTipoExplosion !== EnumTipoExpIns.NoCalcular) {
            if (this.mMapHExplosion.has(llave)) {
              const cantidad: number = this.mMapHExplosion.get(llave);
              if (datosCatalogo.Nivel === 0) {
                tExpinsl = true;
              } else {
                if (datosCatalogo.InsumoIntegrado) {
                  if (!this.mExplotarInsumosIntegrados) {
                    tExpinsl = true;
                  }
                } else {
                  if (datosCatalogo.TchFij === EnumTipoTchFij.CostoHorario) {
                    if (!this.mExplotarInsumoCH) {
                      tExpinsl = true;
                    }
                  } else if (datosCatalogo.TchFij === EnumTipoTchFij.CargoFijo) {
                    if (this.mExplotarInsumoCH) {
                      tExpinsl = true;
                    }
                    if (datosCatalogo.TchFij === EnumTipoTchFij.CargoFijo) {
                      datosCatalogo.Nivel = 0;
                      if (datosCatalogo.Nivel !== valueOriginal.Nivel) {
                        cambioCatalogo = true;
                      }
                    }
                  }
                }
              }
              if (datosCatalogo.Expins !== cantidad) {
                cambioExpIns = true;
                datosCatalogo.Expins = cantidad;
              }
            } else {
              datosCatalogo.Expins = 0;
              if (datosCatalogo.Expins !== valueOriginal.Expins) {
                cambioExpIns = true;
              }
            }
            if (valueOriginal.ExpInsl !== tExpinsl) {
              datosCatalogo.Expinsl = tExpinsl;
              cambioExpIns = true;
            }
          } else {
            // no calcular Exp de insumos
            datosCatalogo.Expinsl = valueOriginal.ExpInsl;
          }
        }
        if (cambioCatalogo || cambioExpIns) {
          const guardar: ClsCalculoGuardarCatalogo = {
            IdCatalogo: llave,
            Nivel: datosCatalogo.Nivel,
            CostoMoneda1: datosCatalogo.CostoMoneda1,
            CostoMoneda2: datosCatalogo.CostoMoneda2,
            Expins: datosCatalogo.Expins,
            Expinsl: datosCatalogo.Expinsl
          };
          arrayCatalogoGuardar.push(guardar);
        }
      });
      return arrayCatalogoGuardar;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private generarCostosCalculo(): ClsCatalogoCalculo[] {
    const arrayCatalogoCalculoGuardar: ClsCatalogoCalculo[] = [];
    let datosCatalogo: ClsCalculoCatalogo;
    try {
      this.infPpto.pptoActivoCompletoJSON.CatExpIns.forEach(valueOriginal => {
        const llave: bigint = ClsUtil.bigintX(valueOriginal.IdCatalogo);
        let cambioCostos: boolean = false;
        const calculo: ClsCatalogoCalculo = new ClsCatalogoCalculo();
        if (this.mMapHCatalogo.has(llave)) {
          datosCatalogo = this.mMapHCatalogo.get(llave);
          const costoCal: ClsCatalogoCostosCalculo = this.mMapHCostoCalculo.get(llave);
          // si es null es nuevo registro o es la primera vez que se genera el archivo de costos calculo
          if (ClsUtil.esNulo(costoCal)) {
            cambioCostos = true;
          } else {
            if (datosCatalogo.Costo93Moneda1 !== costoCal.Costo93Moneda1 || datosCatalogo.Costo94Moneda1 !== costoCal.Costo94Moneda1 || datosCatalogo.Costo95Moneda1 !== costoCal.Costo95Moneda1 ||
              datosCatalogo.Costo96Moneda1 !== costoCal.Costo96Moneda1 || datosCatalogo.Costo97Moneda1 !== costoCal.Costo97Moneda1 || datosCatalogo.Costo98Moneda1 !== costoCal.Costo98Moneda1 ||
              datosCatalogo.Costo93Moneda2 !== costoCal.Costo93Moneda2 || datosCatalogo.Costo94Moneda2 !== costoCal.Costo94Moneda2 || datosCatalogo.Costo95Moneda2 !== costoCal.Costo95Moneda2 ||
              datosCatalogo.Costo96Moneda2 !== costoCal.Costo96Moneda2 || datosCatalogo.Costo97Moneda2 !== costoCal.Costo97Moneda2 || datosCatalogo.Costo98Moneda2 !== costoCal.Costo98Moneda2 ||
              datosCatalogo.Costo93Moneda3 !== costoCal.Costo93Moneda3 || datosCatalogo.Costo94Moneda3 !== costoCal.Costo94Moneda3 || datosCatalogo.Costo95Moneda3 !== costoCal.Costo95Moneda3 ||
              datosCatalogo.Costo96Moneda3 !== costoCal.Costo96Moneda3 || datosCatalogo.Costo97Moneda3 !== costoCal.Costo97Moneda3 || datosCatalogo.Costo98Moneda3 !== costoCal.Costo98Moneda3) {
              cambioCostos = true;
            }
          }
        }
        if (cambioCostos) {
          calculo.IdCatalogo = llave;
          calculo.JsonCatalogoCostosCalculo = '';
          calculo.CatalogoCostosCalculo = [{
            Costo93Moneda1: datosCatalogo.Costo93Moneda1,
            Costo94Moneda1: datosCatalogo.Costo94Moneda1,
            Costo95Moneda1: datosCatalogo.Costo95Moneda1,
            Costo96Moneda1: datosCatalogo.Costo96Moneda1,
            Costo97Moneda1: datosCatalogo.Costo97Moneda1,
            Costo98Moneda1: datosCatalogo.Costo98Moneda1,
            Costo93Moneda2: datosCatalogo.Costo93Moneda2,
            Costo94Moneda2: datosCatalogo.Costo94Moneda2,
            Costo95Moneda2: datosCatalogo.Costo95Moneda2,
            Costo96Moneda2: datosCatalogo.Costo96Moneda2,
            Costo97Moneda2: datosCatalogo.Costo97Moneda2,
            Costo98Moneda2: datosCatalogo.Costo98Moneda2,
            Costo93Moneda3: datosCatalogo.Costo93Moneda3,
            Costo94Moneda3: datosCatalogo.Costo94Moneda3,
            Costo95Moneda3: datosCatalogo.Costo95Moneda3,
            Costo96Moneda3: datosCatalogo.Costo96Moneda3,
            Costo97Moneda3: datosCatalogo.Costo97Moneda3,
            Costo98Moneda3: datosCatalogo.Costo98Moneda3
          }];
          calculo.JsonCatalogoCostosOP = '';
          calculo.CatalogoCostosOP = [];
          calculo.JsonCatalogoMO = '';
          calculo.CatalogoMO = [];
          arrayCatalogoCalculoGuardar.push(calculo);
        }
      });
      return arrayCatalogoCalculoGuardar;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private generarCostosMOCalculo(): ClsCatalogoCalculo[] {
    const arrayCatalogoCalculoGuardar: ClsCatalogoCalculo[] = [];
    let datosMO: ClsCatalogoMOCalculo;
    try {
      this.mDataMO.forEach((valueOriginal: ClsManoDeObraMoneda) => {
        const llave: bigint = ClsUtil.bigintX(valueOriginal.IdCatalogo);
        let cambioCostos: boolean = false;
        let costoTotalMonedaCalculando: number = 0;
        const calculo: ClsCatalogoCalculo = new ClsCatalogoCalculo();
        if (this.mMapHCostoMOCalculo.has(llave)) {
          datosMO = this.mMapHCostoMOCalculo.get(llave);
          switch (this.mTipoMonedaCalcular) {
            case 0:
              costoTotalMonedaCalculando = datosMO.CostoTotalMoneda1;
              break;
            case 1:
              costoTotalMonedaCalculando = datosMO.CostoTotalMoneda2;
              break;
            case 2:
              costoTotalMonedaCalculando = datosMO.CostoTotalMoneda3;
              break;
          }
          // valueOriginal.CostoTotal es valor de la moneda que se esta calculando
          if (valueOriginal.CostoTotal !== costoTotalMonedaCalculando) {
            cambioCostos = true;
          }
        }
        if (cambioCostos) {
          calculo.IdCatalogo = llave;
          calculo.JsonCatalogoCostosCalculo = '';
          calculo.CatalogoCostosCalculo = [];
          calculo.JsonCatalogoCostosOP = '';
          calculo.CatalogoCostosOP = [];
          calculo.JsonCatalogoMO = '';
          calculo.CatalogoMO = [{
            SalarioBaseMoneda1: datosMO.SalarioBaseMoneda1,
            FactorSalarioIntegradoMoneda1: datosMO.FactorSalarioIntegradoMoneda1,
            FasarMoneda1: datosMO.FasarMoneda1,
            SalarioIntegradoMoneda1: datosMO.SalarioIntegradoMoneda1,
            SalarioRealMoneda1: datosMO.SalarioRealMoneda1,
            ViaticosMoneda1: datosMO.ViaticosMoneda1,
            AlimentacionYHospedajeMoneda1: datosMO.AlimentacionYHospedajeMoneda1,
            GastosDeSepelioMoneda1: datosMO.GastosDeSepelioMoneda1,
            OtrasPrestacionesMoneda1: datosMO.OtrasPrestacionesMoneda1,
            RiesgosdeTrabajoMoneda1: datosMO.RiesgosdeTrabajoMoneda1,
            TipoFasarMoneda1: datosMO.TipoFasarMoneda1,
            SalarioBaseMoneda2: datosMO.SalarioBaseMoneda2,
            FactorSalarioIntegradoMoneda2: datosMO.FactorSalarioIntegradoMoneda2,
            FasarMoneda2: datosMO.FasarMoneda2,
            SalarioIntegradoMoneda2: datosMO.SalarioIntegradoMoneda2,
            SalarioRealMoneda2: datosMO.SalarioRealMoneda2,
            ViaticosMoneda2: datosMO.ViaticosMoneda2,
            AlimentacionYHospedajeMoneda2: datosMO.AlimentacionYHospedajeMoneda2,
            GastosDeSepelioMoneda2: datosMO.GastosDeSepelioMoneda2,
            OtrasPrestacionesMoneda2: datosMO.OtrasPrestacionesMoneda2,
            RiesgosdeTrabajoMoneda2: datosMO.RiesgosdeTrabajoMoneda2,
            TipoFasarMoneda2: datosMO.TipoFasarMoneda2,
            SalarioBaseMoneda3: datosMO.SalarioBaseMoneda3,
            FactorSalarioIntegradoMoneda3: datosMO.FactorSalarioIntegradoMoneda3,
            FasarMoneda3: datosMO.FasarMoneda3,
            SalarioIntegradoMoneda3: datosMO.SalarioIntegradoMoneda3,
            SalarioRealMoneda3: datosMO.SalarioRealMoneda3,
            ViaticosMoneda3: datosMO.ViaticosMoneda3,
            AlimentacionYHospedajeMoneda3: datosMO.AlimentacionYHospedajeMoneda3,
            GastosDeSepelioMoneda3: datosMO.GastosDeSepelioMoneda3,
            OtrasPrestacionesMoneda3: datosMO.OtrasPrestacionesMoneda3,
            RiesgosdeTrabajoMoneda3: datosMO.RiesgosdeTrabajoMoneda3,
            TipoFasarMoneda3: datosMO.TipoFasarMoneda3
          }];
          arrayCatalogoCalculoGuardar.push(calculo);
        }
      });
      return arrayCatalogoCalculoGuardar;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private generarCostosOPCalculo(): ClsCatalogoCalculo[] {
    const arrayCatalogoCalculoGuardar: ClsCatalogoCalculo[] = [];
    let datosOP: ClsCatalogoCostosOPCalculo;
    try {
      this.mDataOP.forEach((valueOriginal: ClsMaterialesMoneda) => {
        const llave: bigint = ClsUtil.bigintX(valueOriginal.IdCatalogo);
        let cambioCostos: boolean = false;
        let costoLABMonedaCalculando: number = 0;
        const calculo: ClsCatalogoCalculo = new ClsCatalogoCalculo();
        if (this.mMapHCostoOPCalculo.has(llave)) {
          datosOP = this.mMapHCostoOPCalculo.get(llave);
          switch (this.mTipoMonedaCalcular) {
            case 0:
              costoLABMonedaCalculando = datosOP.CostoLABMoneda1;
              break;
            case 1:
              costoLABMonedaCalculando = datosOP.CostoLABMoneda2;
              break;
            case 2:
              costoLABMonedaCalculando = datosOP.CostoLABMoneda3;
              break;
          }
          if (valueOriginal.CostoLab !== costoLABMonedaCalculando) {
            cambioCostos = true;
          }
        }
        if (cambioCostos) {
          calculo.IdCatalogo = llave;
          calculo.JsonCatalogoCostosCalculo = '';
          calculo.CatalogoCostosCalculo = [];
          calculo.JsonCatalogoCostosOP = '';
          calculo.CatalogoCostosOP = [{
            AlmacenajeMoneda1: datosOP.AlmacenajeMoneda1,
            CostoLABMoneda1: datosOP.CostoLABMoneda1,
            DerechosMoneda1: datosOP.DerechosMoneda1,
            FletesMoneda1: datosOP.FletesMoneda1,
            ManiobraMoneda1: datosOP.ManiobraMoneda1,
            MermasMoneda1: datosOP.MermasMoneda1,
            AlmacenajeMoneda2: datosOP.AlmacenajeMoneda2,
            CostoLABMoneda2: datosOP.CostoLABMoneda2,
            DerechosMoneda2: datosOP.DerechosMoneda2,
            FletesMoneda2: datosOP.FletesMoneda2,
            ManiobraMoneda2: datosOP.ManiobraMoneda2,
            MermasMoneda2: datosOP.MermasMoneda2,
            AlmacenajeMoneda3: datosOP.AlmacenajeMoneda3,
            CostoLABMoneda3: datosOP.CostoLABMoneda3,
            DerechosMoneda3: datosOP.DerechosMoneda3,
            FletesMoneda3: datosOP.FletesMoneda3,
            ManiobraMoneda3: datosOP.ManiobraMoneda3,
            MermasMoneda3: datosOP.MermasMoneda3
          }];
          calculo.JsonCatalogoMO = '';
          calculo.CatalogoMO = [];
          arrayCatalogoCalculoGuardar.push(calculo);
        }
      });
      return arrayCatalogoCalculoGuardar;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private generarDatosGuardarPatidas(): ClsCalculoGuardarPartidas[] {
    let datosPartida: ClsCalculoPartidas;
    let jsonConceptos: ClsConceptosPartidasGuardar[] = [];
    const arrayPartidasGuardar: ClsCalculoGuardarPartidas[] = [];
    let cambioPartida: boolean;
    try {
      this.infPpto.pptoActivoCompletoJSON.Partidas.forEach(par => {
        const IdPptoPartida: bigint = ClsUtil.bigintX(par.IdPresupuestoPartida);
        jsonConceptos = [];
        cambioPartida = false;
        if (this.mMapHPartidas.has(IdPptoPartida)) {
          datosPartida = this.mMapHPartidas.get(IdPptoPartida);
          // revisar el detalle de la partida, agregar bandera si cambio algo
          if (datosPartida.Costo1 !== par.CostoMoneda1 || datosPartida.Costo2 !== par.CostoMoneda2
            || datosPartida.Precio1 !== par.PrecioMoneda1 || datosPartida.Precio2 !== par.PrecioMoneda2) {
            cambioPartida = true;
          } else {
            //  si no cambio el encabezado, verificar si hay un detalle
            if (this.mMapJsonConceptos.has(IdPptoPartida)) {
              jsonConceptos = this.mMapJsonConceptos.get(IdPptoPartida);
              jsonConceptos.forEach(value => {
                const llave = `${ClsUtil.cadenaX(IdPptoPartida)}-${value.Control}`;
                if (this.mMapHPartidasDet.has(llave)) {
                  const detalle: ClsConceptosPartidasGuardar = this.mMapHPartidasDet.get(llave);
                  // || value.PrecioMoneda2 !== detalle.PrecioMoneda2
                  if (value.PrecioMoneda1 !== detalle.PrecioMoneda1) {
                    cambioPartida = true;
                  }
                }
              });
            }
          }

          if (cambioPartida) {
            if (this.mMapJsonConceptos.has(IdPptoPartida)) {
              jsonConceptos = this.mMapJsonConceptos.get(IdPptoPartida);
            }
            const partida: ClsCalculoGuardarPartidas = {
              IdPresupuestoPartida: IdPptoPartida,
              CostoMoneda1: datosPartida.Costo1,
              PrecioMoneda1: datosPartida.Precio1,
              CostoMoneda2: datosPartida.Costo2,
              PrecioMoneda2: datosPartida.Precio2,
              JsonConceptos: jsonConceptos
            };
            arrayPartidasGuardar.push(partida);
          }
        }
      });

      return arrayPartidasGuardar;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private inicializarObjCatalogo(idCatalogo: bigint): ClsCalculoCatalogo {
    let result: ClsCalculoCatalogo;
    const catalogo: ClsCatalogosExpIns = this.mMapHExpInsumos.get(idCatalogo);
    const costos: ClsCatalogoCostosCalculo = this.mMapHCostoCalculo.get(idCatalogo);
    if (ClsUtil.esNulo(catalogo)) {
      return undefined;
      // console.log('inicializarObjCatalogo->no existe en el catalgo', idCatalogo);
    } else {
      const esNuloCostos: boolean = ClsUtil.esNulo(costos);
      result = new ClsCalculoCatalogo();
      result.Calculado = false;
      result.CostoMoneda1 = catalogo.CostoMoneda1;
      result.CostoMoneda2 = catalogo.CostoMoneda2;
      result.EsPorcentaje = catalogo.EsPorcentaje;
      result.TipoPorcentaje = catalogo.TipoPorcentaje;
      result.TipoInsumo = catalogo.Tipo;
      result.InsumoIntegrado = catalogo.InsumoIntegrado;
      result.Nivel = catalogo.Nivel;
      result.Expins = catalogo.Expins;
      result.Expinsl = catalogo.ExpInsl;
      result.TchFij = EnumTipoTchFij.NoEsTch;
      result.Costo93Moneda1 = esNuloCostos ? 0 : costos.Costo93Moneda1;
      result.Costo94Moneda1 = esNuloCostos ? 0 : costos.Costo94Moneda1;
      result.Costo95Moneda1 = esNuloCostos ? 0 : costos.Costo95Moneda1;
      result.Costo96Moneda1 = esNuloCostos ? 0 : costos.Costo96Moneda1;
      result.Costo97Moneda1 = esNuloCostos ? 0 : costos.Costo97Moneda1;
      result.Costo98Moneda1 = esNuloCostos ? 0 : costos.Costo98Moneda1;
      result.Costo93Moneda2 = esNuloCostos ? 0 : costos.Costo93Moneda2;
      result.Costo94Moneda2 = esNuloCostos ? 0 : costos.Costo94Moneda2;
      result.Costo95Moneda2 = esNuloCostos ? 0 : costos.Costo95Moneda2;
      result.Costo96Moneda2 = esNuloCostos ? 0 : costos.Costo96Moneda2;
      result.Costo97Moneda2 = esNuloCostos ? 0 : costos.Costo97Moneda2;
      result.Costo98Moneda2 = esNuloCostos ? 0 : costos.Costo98Moneda2;
      result.Costo93Moneda3 = esNuloCostos ? 0 : costos.Costo93Moneda3;
      result.Costo94Moneda3 = esNuloCostos ? 0 : costos.Costo94Moneda3;
      result.Costo95Moneda3 = esNuloCostos ? 0 : costos.Costo95Moneda3;
      result.Costo96Moneda3 = esNuloCostos ? 0 : costos.Costo96Moneda3;
      result.Costo97Moneda3 = esNuloCostos ? 0 : costos.Costo97Moneda3;
      result.Costo98Moneda3 = esNuloCostos ? 0 : costos.Costo98Moneda3;
    }
    return result;
  }

  private inicializarCH(ch: ClsCostoHorarios): ClsCostoHorarios {
    return {
      IdCatalogoCostoHorario: ch.IdCatalogoCostoHorario,
      CalculoDetallado: ch.CalculoDetallado,
      Ccarter: ch.Ccarter,
      Faceite: ch.Faceite,
      Factcomb: ch.Factcomb,
      FactFuentes: ch.FactFuentes,
      Foper: ch.Foper,
      Ha: ch.Ha,
      Hllantas: ch.Hllantas,
      Horasc: ch.Horasc,
      HPiezas: ch.HPiezas,
      IdCatalogoE: ClsUtil.bigintX(ch.IdCatalogoE),
      IdCatalogoR: ClsUtil.bigintX(ch.IdCatalogoR),
      IdCatalogoVa: ClsUtil.bigintX(ch.IdCatalogoVa),
      IdCatalogoAcei: ClsUtil.bigintX(ch.IdCatalogoAcei),
      IdCatalogoPza: ClsUtil.bigintX(ch.IdCatalogoPza),
      IdCatalogoLla: ClsUtil.bigintX(ch.IdCatalogoLla),
      IdCatalogoComb: ClsUtil.bigintX(ch.IdCatalogoComb),
      IdCatalogoOtrasFuentes: ClsUtil.bigintX(ch.IdCatalogoOtrasFuentes),
      Potencia: ch.Potencia,
      Q: ch.Q,
      S: ch.S,
      Ve: ch.Ve,
      Vr: ch.Vr,
      TasaInteresMoneda1: ch.TasaInteresMoneda1,
      TasaInteresMoneda2: ch.TasaInteresMoneda2,
      CantidadCombustible: ch.CantidadCombustible,
      CantidadLubricante: ch.CantidadLubricante,
      LsCostosHorariosMO: ch.LsCostosHorariosMO,
      LsCostosHorariosOC: ch.LsCostosHorariosOC,
    };
  }

  private llenarMapas() {
    try {
      // llenar el Map Catalogo los IdCodigoMatriz y IdCodigoInsumo de todas las matrices
      this.mLMatrices.forEach(matriz => {
        const IdCodigoMatriz: bigint = ClsUtil.bigintX(matriz.IdCodigoMatriz);
        // se valida que no exista el IdCodigoMatriz en el mapa catalogo para agregarlo
        if (!this.mMapHCatalogo.has(IdCodigoMatriz)) {
          this.mMapHCatalogo.set(IdCodigoMatriz, this.inicializarObjCatalogo(IdCodigoMatriz));
        }
        // se valida que no exista el IdCodigoMatriz en el mapa matrices para agregarlo
        if (!this.mMapHMatriz.has(IdCodigoMatriz)) {
          // validamos que JsonMatriz sea mayor que 0 para agregarlo al Map Matrices
          if (matriz.JsonMatriz.length > 0) {
            const insMat: ClsCalculoMatriz[] = ClsUtil.parseJSONBig(matriz.JsonMatriz);
            insMat.forEach(insumo => {
              insumo.IdCodigoInsumo = ClsUtil.bigintX(insumo.IdCodigoInsumo);
            });
            this.mMapHMatriz.set(IdCodigoMatriz, insMat);
            insMat.forEach(insumo => {
              const IdCodigoInsumo: bigint = ClsUtil.bigintX(insumo.IdCodigoInsumo);
              // se valida que no exista el IdCodigoInsumo en el mapa catalogo para agregarlo
              if (!this.mMapHCatalogo.has(IdCodigoInsumo)) {
                this.mMapHCatalogo.set(IdCodigoInsumo, this.inicializarObjCatalogo(IdCodigoInsumo));
              }
            });
          }
        }
      });
      //  llenar el Map Catalogo los idCatalogo del presupuesto
      this.infPpto.pptoActivoCompletoJSON.Presupuesto.forEach(ppto => {
        const IdCatalogo: bigint = ClsUtil.bigintX(ppto.IdCatalogo);
        const llave = `${ClsUtil.cadenaX(ppto.IdPresupuestoPartida)}-${ClsUtil.cadenaX(ppto.Control)}`;
        // se valida que no exista el IdCatalogo del ppto en el mapa catalogo para agregarlo
        if (!this.mMapHCatalogo.has(IdCatalogo)) {
          this.mMapHCatalogo.set(IdCatalogo, this.inicializarObjCatalogo(IdCatalogo));
        }
        this.mMapHPartidasDet.set(llave, {
          IdCatalogo,
          PrecioMoneda1: ppto.PrecioMoneda1,
          PrecioMoneda2: ppto.PrecioMoneda2,
          Control: ppto.Control
        });
      });
      //  Actualizar costos hasta al final, son datos que no participan en el ppto
      // this.infPpto.pptoActivoCompletoJSON.CatExpIns.forEach(expIns => {
      //   const IdCatalogo: bigint = ClsUtil.bigintX(expIns.IdCatalogo);
      //   if (!this.mMapHCatalogo.has(IdCatalogo)) {
      //     if (expIns.Nivel !== 0 || expIns.ExpInsl === true || expIns.Expins !== 0) {
      //       expIns.Nivel = 0;
      //       expIns.ExpInsl = false;
      //       expIns.Expins = 0;
      //       this.mMapHCatalogo.set(IdCatalogo, this.inicializarObjCatalogo(IdCatalogo));
      //     }
      //   }
      // });

      // barrer los CH, CF, E, R, VA, etc... a mMapHCatalogo
      // en este mismo ciclo se hace lo del metodo CargaMatricesTch, CargaEsperaYReserva que esta en el codigo de escritorio,
      // los metodos CargaHMatricesOC, CargaHMatricesMO, no se ocupan ya que el servicio lo trae en un arreglo y se puede ocupar tal cual para el metodo
      // CargaMatricesTch y el metodo CargaHCostosHorarios no se agrega en Mapa ya que el servicio lo trae como se requiere
      let arrayMatriz: ClsCalculoMatriz[];
      this.mLCostoHorarios.forEach(value => {
        const IdCH: bigint = ClsUtil.bigintX(value.IdCatalogoCostoHorario);
        const IdCF: bigint = ClsUtil.bigintX(value.IdCatalogoCF);
        const IdE: bigint = ClsUtil.bigintX(value.IdCatalogoE);
        const IdR: bigint = ClsUtil.bigintX(value.IdCatalogoR);
        const IdVA: bigint = ClsUtil.bigintX(value.IdCatalogoVa);
        const IdLla: bigint = ClsUtil.bigintX(value.IdCatalogoLla);
        const IdPza: bigint = ClsUtil.bigintX(value.IdCatalogoPza);
        const IdCom: bigint = ClsUtil.bigintX(value.IdCatalogoComb);
        const IdLub: bigint = ClsUtil.bigintX(value.IdCatalogoAcei);
        const IdOFE: bigint = ClsUtil.bigintX(value.IdCatalogoOtrasFuentes);
        // agregar CH
        if (this.mMapHCatalogo.has(IdCH)) {
          const CH: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdCH);
          CH.TchFij = EnumTipoTchFij.CostoHorario;
          this.mMapHCatalogo.set(IdCH, CH);
        } else {
          const CH: ClsCalculoCatalogo = this.inicializarObjCatalogo(IdCH);
          CH.TchFij = EnumTipoTchFij.CostoHorario;
          this.mMapHCatalogo.set(IdCH, CH);
        }
        // agregar CF
        if (!this.mMapHCatalogo.has(IdCF)) {
          const CF: ClsCalculoCatalogo = this.inicializarObjCatalogo(IdCF);
          CF.TchFij = EnumTipoTchFij.CargoFijo;
          this.mMapHCatalogo.set(IdCF, CF);
        }
        // agregar E
        if (IdE > BigInt('0') && !this.mMapHCatalogo.has(IdE)) {
          this.mMapHCatalogo.set(IdE, this.inicializarObjCatalogo(IdE));
          // carga espera y reserva
          // if (!this.mMapEsperaReserva.has(IdE)) {
          //   this.mMapEsperaReserva.set(IdE, IdCF);
          // }
        }
        // agregar R
        if (IdR > BigInt('0') && !this.mMapHCatalogo.has(IdR)) {
          this.mMapHCatalogo.set(IdR, this.inicializarObjCatalogo(IdR));
          // carga espera y reserva
          // if (!this.mMapEsperaReserva.has(IdR)) {
          //   this.mMapEsperaReserva.set(IdR, IdCF);
          // }
        }
        // agregar VA
        if (IdVA > BigInt('0') && !this.mMapHCatalogo.has(IdVA)) {
          this.mMapHCatalogo.set(IdVA, this.inicializarObjCatalogo(IdVA));
        }
        // agregar Lla
        if (IdLla > BigInt('0') && !this.mMapHCatalogo.has(IdLla)) {
          this.mMapHCatalogo.set(IdLla, this.inicializarObjCatalogo(IdLla));
        }
        // agregar Pza
        if (IdPza > BigInt('0') && !this.mMapHCatalogo.has(IdPza)) {
          this.mMapHCatalogo.set(IdPza, this.inicializarObjCatalogo(IdPza));
        }
        // agregar Combustible
        if (IdCom > BigInt('0') && !this.mMapHCatalogo.has(IdCom)) {
          this.mMapHCatalogo.set(IdCom, this.inicializarObjCatalogo(IdCom));
        }
        // agregar Lubricante
        if (IdLub > BigInt('0') && !this.mMapHCatalogo.has(IdLub)) {
          this.mMapHCatalogo.set(IdLub, this.inicializarObjCatalogo(IdLub));
        }
        // agregar Otras Fuentes
        if (IdOFE > BigInt('0') && !this.mMapHCatalogo.has(IdOFE)) {
          this.mMapHCatalogo.set(IdOFE, this.inicializarObjCatalogo(IdOFE));
        }
        // esto es lo que hace el metodo CargaMatricesTch
        this.limpiaLibroDatosParticulares();
        arrayMatriz = [];
        // validamos LsCostosHorariosMO y LsCostosHorariosOC que tengan registros
        if (value.LsCostosHorariosMO.length > 0) {
          value.LsCostosHorariosMO.forEach(value1 => {
            // agregar en map catalogo si no existe
            const idMO: bigint = ClsUtil.bigintX(value1.IdCatalogoMO);
            if (!this.mMapHCatalogo.has(idMO)) {
              this.mMapHCatalogo.set(idMO, this.inicializarObjCatalogo(idMO));
            }
            if (this.mMapHCatalogo.has(idMO)) {
              arrayMatriz.push({IdCodigoInsumo: idMO, Dividir: true, Volumen: value1.Volumen});
            }
          });
          this.vaciaOperacionAExcel(value.LsCostosHorariosMO);
        }
        if (value.LsCostosHorariosOC.length > 0) {
          value.LsCostosHorariosOC.forEach(value1 => {
            // agregar en map catalogo si no existe
            const idOC: bigint = ClsUtil.bigintX(value1.IdCatalogoOC);
            if (!this.mMapHCatalogo.has(idOC)) {
              this.mMapHCatalogo.set(idOC, this.inicializarObjCatalogo(idOC));
            }
            if (this.mMapHCatalogo.has(idOC)) {
              arrayMatriz.push({IdCodigoInsumo: idOC, Dividir: false, Volumen: value1.Volumen});
            }
          });
          this.vaciaOtrosConsumosAExcel(value.LsCostosHorariosOC);
        }
        this.vaciaDatosExcel(value);
        // renglon CF
        if (IdCF > BigInt('0')) {
          arrayMatriz.push({IdCodigoInsumo: IdCF, Dividir: false, Volumen: 1});
        }
        // renglon Lla
        if (IdLla > BigInt('0')) {
          arrayMatriz.push({IdCodigoInsumo: IdLla, Dividir: true, Volumen: value.Hllantas});
        }
        // renglon Pza
        if (IdPza > BigInt('0')) {
          arrayMatriz.push({IdCodigoInsumo: IdPza, Dividir: true, Volumen: value.HPiezas});
        }
        // renglon Otras Fuentes
        if (IdOFE > BigInt('0')) {
          arrayMatriz.push({IdCodigoInsumo: IdOFE, Dividir: false, Volumen: value.FactFuentes});
        }
        // renglon Lub
        if (IdLub > BigInt('0')) {
          const cantLub: number = ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CantidadLubricante').value);
          arrayMatriz.push({IdCodigoInsumo: IdLub, Dividir: false, Volumen: cantLub});
        }
        // renglon Comb
        if (IdCom > BigInt('0')) {
          const cantComb: number = ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CantidadCombustible').value);
          arrayMatriz.push({IdCodigoInsumo: IdCom, Dividir: false, Volumen: cantComb});
        }
        this.mMapHMatriz.set(IdCH, arrayMatriz);
        // agregar CH a mMap
        if (!this.mMapCostoHorariosCF.has(IdCF)) {
          this.mMapCostoHorariosCF.set(IdCF, this.inicializarCH(value));
        }
      });
      //  llenar el Map Partidas los idCatalogo del presupuesto,
      // se valida si es Moneda 1 o 2 para inicializar su valor y no se vaya acumulando
      // esta validacion se agrego porque cuando calculas moneda 1 agrega sus valores, pero al calcular monede 2, se reinician todos los valores(M1 y M2), pero debe de dejar el valor de M1 antes calculado
      const isMoneda1 = this.mTipoMonedaCalcular === 0;
      const isMoneda2 = this.mTipoMonedaCalcular === 1;
      this.infPpto.pptoActivoCompletoJSON.Partidas.forEach(par => {
        this.mMapHPartidas.set(ClsUtil.bigintX(par.IdPresupuestoPartida), {
          IdPartidaPadre: ClsUtil.bigintX(par.IdPartidaPadre),
          Costo1: isMoneda1 ? 0 : par.CostoMoneda1,
          Precio1: isMoneda1 ? 0 : par.PrecioMoneda1,
          Costo2: isMoneda2 ? 0 : par.CostoMoneda2,
          Precio2: isMoneda2 ? 0 : par.PrecioMoneda2,
        });
      });
      // remover los idcatalogos que tiene matriz sin analisis,
      this.mMapHCatalogo.forEach((value, key) => {
        if (ClsUtil.esNulo(value)) {
          this.mMapHCatalogo.delete(key);
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calcularCostoOP() {
    try {
      let diferencia: number;
      const esMoneda1: boolean = this.mTipoMonedaCalcular === 0;
      this.mDataOP = this.mObjMateriales.crearObjMATEnBaseMonedaSeleccionada(esMoneda1);
      this.mMapHCostoOPCalculo = ClsUtil.crearMapIdCatalogo(this.infPpto.pptoActivoCompletoJSON.CostosOPCalculo);
      this.mLCostoOPCalculoBorrar = [];
      this.mDataOP.forEach((costoOP: ClsMaterialesMoneda) => {
        let costoLab: number = costoOP.CostoLab;
        const costo: number = costoOP.Costo;
        const key: bigint = ClsUtil.bigintX(costoOP.IdCatalogo);
        const sumaDetalle: number = ClsUtil.redondearMoneda(costoLab + costoOP.Fletes + costoOP.Maniobra + costoOP.Almacenaje + costoOP.Derechos + costoOP.Mermas, this.infPpto.decimalredondearimporte);
        if (costo != sumaDetalle) {
          diferencia = ClsUtil.redondearMoneda(costo - sumaDetalle, this.infPpto.decimalredondearimporte);
          // si hay diferencias en costo debe ajustarlo en el costolab
          costoLab = ClsUtil.redondearMoneda(costoLab + diferencia, this.infPpto.decimalredondearimporte);
          // validar que no quede negativo
          if (costoLab > 0) {
            if (this.mMapHCostoOPCalculo.has(key)) {
              const calculoCostoOP: ClsCatalogoCostosOPCalculo = this.mMapHCostoOPCalculo.get(key);
              // Aquí debe actualizar el valor del costolab
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  calculoCostoOP.CostoLABMoneda1 = costoLab;
                  break;
                case 1:
                  calculoCostoOP.CostoLABMoneda2 = costoLab;
                  break;
                default: // moneda 3
                  calculoCostoOP.CostoLABMoneda3 = costoLab;
                  break;
              }
              this.mMapHCostoOPCalculo.set(key, calculoCostoOP);
            }
          } else {
            // En caso de que quede negativo simplemente se guarda en la lista para ser borrado
            this.mLCostoOPCalculoBorrar.push(key);
          }
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async calcularSalarios() {
    try {
      const esMoneda1: boolean = this.mTipoMonedaCalcular === 0;
      this.mObjMO.mObjGenerico = this.mObjGenerico;
      this.mDataMO = await this.mObjMO.crearObjMOEnBaseMonedaSeleccionada(esMoneda1);
      this.mMapHCostoMOCalculo = ClsUtil.crearMapIdCatalogo(this.infPpto.pptoActivoCompletoJSON.CostosMOCalculo);
      this.mDataMO.forEach((costoMO: ClsManoDeObraMoneda) => {
        const key: bigint = ClsUtil.bigintX(costoMO.IdCatalogo);
        let costoTotal: number = costoMO.CostoTotal;
        if (this.mMapHCostoMOCalculo.has(key)) {
          const costosMOCalculo: ClsCatalogoMOCalculo = this.mMapHCostoMOCalculo.get(key);
          const restaGastos: number = ClsUtil.redondearMoneda(costoTotal - costoMO.Viaticos - costoMO.AlimentacionHospedaje - costoMO.GastosSepelio - costoMO.OtrasPrestaciones, this.infPpto.decimalredondearimporte);
          switch (this.mTipoMonedaCalcular) {
            case 0:
              // 1o lo debe calcular en reversa porque debe mandar el costototal
              costosMOCalculo.CostoTotalMoneda1 = costoMO.CostoTotal;
              costosMOCalculo.ViaticosMoneda1 = costoMO.Viaticos;
              costosMOCalculo.AlimentacionYHospedajeMoneda1 = costoMO.AlimentacionHospedaje;
              costosMOCalculo.GastosDeSepelioMoneda1 = costoMO.GastosSepelio;
              costosMOCalculo.OtrasPrestacionesMoneda1 = costoMO.OtrasPrestaciones;
              costosMOCalculo.SalarioRealMoneda1 = restaGastos;
              costosMOCalculo.FactorSalarioIntegradoMoneda1 = costoMO.FactorSalarioIntegrado;
              costosMOCalculo.FasarMoneda1 = costoMO.Fasar;
              if (costosMOCalculo.FasarMoneda1 !== 0) {
                costosMOCalculo.SalarioBaseMoneda1 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioRealMoneda1 / costosMOCalculo.FasarMoneda1, this.infPpto.decimalredondearimporte);
                costosMOCalculo.SalarioIntegradoMoneda1 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioBaseMoneda1 * costosMOCalculo.FactorSalarioIntegradoMoneda1, this.infPpto.decimalredondearimporte);
                // 2o. lo calcula hacia adelante una vez calculado en reversa
                costosMOCalculo.SalarioRealMoneda1 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioBaseMoneda1 * costosMOCalculo.FasarMoneda1, this.infPpto.decimalredondearimporte);
                costosMOCalculo.CostoTotalMoneda1 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioRealMoneda1 + costoMO.Viaticos + costoMO.AlimentacionHospedaje + costoMO.GastosSepelio + costoMO.OtrasPrestaciones, this.infPpto.decimalredondearimporte);
                // modificar la lista
                if ((costosMOCalculo.SalarioIntegradoMoneda1 !== costoMO.SalarioIntegrado) ||
                  (costosMOCalculo.SalarioRealMoneda1 !== costoMO.SalarioReal) || (costosMOCalculo.SalarioBaseMoneda1 !== costoMO.SalarioBase)) {
                  this.mMapHCostoMOCalculo.set(key, costosMOCalculo);
                }
              }
              break;
            case 1:
              // 1o lo debe calcular en reversa porque debe mandar el costototal
              costosMOCalculo.CostoTotalMoneda2 = costoMO.CostoTotal;
              costosMOCalculo.ViaticosMoneda2 = costoMO.Viaticos;
              costosMOCalculo.AlimentacionYHospedajeMoneda2 = costoMO.AlimentacionHospedaje;
              costosMOCalculo.GastosDeSepelioMoneda2 = costoMO.GastosSepelio;
              costosMOCalculo.OtrasPrestacionesMoneda2 = costoMO.OtrasPrestaciones;
              costosMOCalculo.SalarioRealMoneda2 = restaGastos;
              costosMOCalculo.FactorSalarioIntegradoMoneda2 = costoMO.FactorSalarioIntegrado;
              costosMOCalculo.FasarMoneda2 = costoMO.Fasar;
              if (costosMOCalculo.FasarMoneda2 !== 0) {
                costosMOCalculo.SalarioBaseMoneda2 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioRealMoneda2 / costosMOCalculo.FasarMoneda2, this.infPpto.decimalredondearimporte);
                costosMOCalculo.SalarioIntegradoMoneda2 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioBaseMoneda2 * costosMOCalculo.FactorSalarioIntegradoMoneda2, this.infPpto.decimalredondearimporte);
                // 2o. lo calcula hacia adelante una vez calculado en reversa
                costosMOCalculo.SalarioRealMoneda2 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioBaseMoneda2 * costosMOCalculo.FasarMoneda2, this.infPpto.decimalredondearimporte);
                costosMOCalculo.CostoTotalMoneda2 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioRealMoneda2 + costoMO.Viaticos + costoMO.AlimentacionHospedaje + costoMO.GastosSepelio + costoMO.OtrasPrestaciones, this.infPpto.decimalredondearimporte);
                // modificar la lista
                if ((costosMOCalculo.SalarioIntegradoMoneda2 !== costoMO.SalarioIntegrado) ||
                  (costosMOCalculo.SalarioRealMoneda2 !== costoMO.SalarioReal) || (costosMOCalculo.SalarioBaseMoneda2 !== costoMO.SalarioBase)) {
                  this.mMapHCostoMOCalculo.set(key, costosMOCalculo);
                }
              }
              break;
            default: // moneda 3
              // 1o lo debe calcular en reversa porque debe mandar el costototal
              costosMOCalculo.CostoTotalMoneda3 = costoMO.CostoTotal;
              costosMOCalculo.ViaticosMoneda3 = costoMO.Viaticos;
              costosMOCalculo.AlimentacionYHospedajeMoneda3 = costoMO.AlimentacionHospedaje;
              costosMOCalculo.GastosDeSepelioMoneda3 = costoMO.GastosSepelio;
              costosMOCalculo.OtrasPrestacionesMoneda3 = costoMO.OtrasPrestaciones;
              costosMOCalculo.SalarioRealMoneda3 = restaGastos;
              costosMOCalculo.FactorSalarioIntegradoMoneda3 = costoMO.FactorSalarioIntegrado;
              costosMOCalculo.FasarMoneda3 = costoMO.Fasar;
              if (costosMOCalculo.FasarMoneda3 !== 0) {
                costosMOCalculo.SalarioBaseMoneda3 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioRealMoneda3 / costosMOCalculo.FasarMoneda3, this.infPpto.decimalredondearimporte);
                costosMOCalculo.SalarioIntegradoMoneda3 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioBaseMoneda3 * costosMOCalculo.FactorSalarioIntegradoMoneda3, this.infPpto.decimalredondearimporte);
                // 2o. lo calcula hacia adelante una vez calculado en reversa
                costosMOCalculo.SalarioRealMoneda3 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioBaseMoneda3 * costosMOCalculo.FasarMoneda3, this.infPpto.decimalredondearimporte);
                costosMOCalculo.CostoTotalMoneda3 = ClsUtil.redondearMoneda(costosMOCalculo.SalarioRealMoneda3 + costoMO.Viaticos + costoMO.AlimentacionHospedaje + costoMO.GastosSepelio + costoMO.OtrasPrestaciones, this.infPpto.decimalredondearimporte);
                // modificar la lista
                if ((costosMOCalculo.SalarioIntegradoMoneda3 !== costoMO.SalarioIntegrado) ||
                  (costosMOCalculo.SalarioRealMoneda3 !== costoMO.SalarioReal) || (costosMOCalculo.SalarioBaseMoneda3 !== costoMO.SalarioBase)) {
                  this.mMapHCostoMOCalculo.set(key, costosMOCalculo);
                }
              }
              break;
          }
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calcularMat() {
    try {
      // ordenar mMapHCatalogo por Nivel
      const arrayCatalogo: ClsCalculoOrderNivel[] = ClsUtil.ordenarMapXNivel(this.mMapHCatalogo);
      arrayCatalogo.forEach(expIns => {
        const IdCatalogo: bigint = ClsUtil.bigintX(expIns.IdCatalogo);
        if (this.mMapHCatalogo.has(IdCatalogo)) {
          this.procesarUnaMatriz(IdCatalogo);
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private procesarUnaMatriz(IdCatalogo: bigint) {
    let datosCatalogo: ClsCalculoCatalogo;
    let msg: string;
    try {
      this.mPila.push(IdCatalogo);
      while (this.mPila.size() > 0) {
        //  validar referencia circular
        if (this.mPila.size() > 49) {
          msg = this.getTranslationsAlertReferenciaCircular();
          // msg = 'El cálculo detectó un problema de referencia circular. ';
          // msg = msg + 'Los códigos de las matrices que se muestran a continuación, están contenidos ';
          // msg = msg + 'unos dentro de los otros: ';
          while (this.mPila.size() > 0) {
            msg = msg + ' -> ' + this.mMapHExpInsumos.get(this.mPila.pop()).Codigo;
          }
          throw new Error(msg);
        }
        IdCatalogo = this.mPila.pop();
        if (this.mMapHMatriz.has(IdCatalogo)) {
          this.cal1Mat(IdCatalogo);
        } else {
          // validar si esta calculado
          if (this.mMapHCatalogo.has(IdCatalogo)) {
            datosCatalogo = this.mMapHCatalogo.get(IdCatalogo);
            if (!datosCatalogo.Calculado) {
              //  validar si IdCatalogo existe en la mLCostoHorarios como IdCatalogoCF, si es diferente de null existe
              if (this.mMapCostoHorariosCF.has(IdCatalogo)) {
                this.calculaUnCostoHorario(IdCatalogo);
              } else {
                // manda calcular el costo horario
                // if (this.mMapEsperaReserva.has(IdCatalogo)) {
                //   const idCF: bigint = this.mMapEsperaReserva.get(IdCatalogo);
                //   const esperaReserva: ClsCostoHorarios = this.mLCostoHorarios.find(value => ClsUtil.bigintX(value.IdCatalogoCF) === idCF);
                //   this.calculaUnCostoHorario(esperaReserva);
                // }
                //  aquí deberia actualizar los costos del insumo en caso de que sea una moneda calculada
                datosCatalogo.Nivel = 0;
                if (datosCatalogo.TipoInsumo === 2) {
                  // si es mano de obra le pasa los datos del salario
                  switch (this.mTipoMonedaCalcular) {
                    case 0:
                      datosCatalogo.Costo96Moneda1 = datosCatalogo.CostoMoneda1;
                      datosCatalogo.Costo97Moneda1 = this.obtieneSalarioIntegrado(IdCatalogo);
                      datosCatalogo.Costo93Moneda1 = datosCatalogo.Costo97Moneda1;
                      datosCatalogo.Costo98Moneda1 = datosCatalogo.Costo96Moneda1;
                      break;
                    case 1:
                      datosCatalogo.Costo96Moneda2 = datosCatalogo.CostoMoneda2;
                      datosCatalogo.Costo97Moneda2 = this.obtieneSalarioIntegrado(IdCatalogo);
                      datosCatalogo.Costo93Moneda2 = datosCatalogo.Costo97Moneda2;
                      datosCatalogo.Costo98Moneda2 = datosCatalogo.Costo96Moneda2;
                      break;
                    case 2:
                      datosCatalogo.Costo96Moneda3 = datosCatalogo.CostoMoneda3;
                      datosCatalogo.Costo97Moneda3 = this.obtieneSalarioIntegrado(IdCatalogo);
                      datosCatalogo.Costo93Moneda3 = datosCatalogo.Costo97Moneda3;
                      datosCatalogo.Costo98Moneda3 = datosCatalogo.Costo96Moneda3;
                      break;
                  }
                  // costo93 seria igual a costo97 (para el caso de un insumo)
                  // costo98 seria igual a costo96 (para el caso de un insumo)
                }
                datosCatalogo.Calculado = true;
                // actualizar mMapHCatalogo
                this.mMapHCatalogo.set(IdCatalogo, datosCatalogo);
              }
            }
          }
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private cal1Mat(IdCatalogo: bigint) {
    let arrayMatriz: ClsCalculoMatriz[];
    let claveInsumo: bigint;
    let calculado: boolean;
    let datosCatalogo: ClsCalculoCatalogo;
    // let cambioMatriz: boolean;
    let totPar: number; // Importe del renglón
    let costo1T: number; // Total de la matriz
    // let totMatriz = 0; // Total de los renglones que NO son %
    this.mTotMA2 = 0; // total de materiales que son %
    this.mTotMA3 = 0; // total de materiales de sus basicos
    this.mTotMO2 = 0; // total de mano de obra que son %
    this.mTotMO3 = 0; // total de la mano de obra gravable esta matriz y de sus basicos
    this.mTotMoTotal = 0; // total de la mano de obra de esta matriz y sus basicos
    this.mTotMoGravableEstaMatriz = 0; //  Total de la mano de obra gravable de esta matriz
    let totOtr = 0; // Total de los renglones que son %
    this.nivelT = 0; // Pone el nivel base de la matriz
    // CH
    let hayUnCargoFijo: boolean;
    let claveCF: bigint = BigInt('0');
    let datosTch: ClsCostoHorarios;

    this.mTotMatriz = 0; // Total de los renglones que NO son %
    this.mMapHTipos.clear();
    this.mMapHTipos.set(1, 0);
    this.mMapHTipos.set(2, 0);
    this.mMapHTipos.set(3, 0);

    this.mCosto93 = 0;
    this.mCosto94 = 0;
    this.mCosto95 = 0;
    this.mCosto96 = 0;
    this.mCosto97 = 0;
    this.mCosto98 = 0;

    try {
      arrayMatriz = this.mMapHMatriz.get(IdCatalogo);
      hayUnCargoFijo = false;
      for (const value of arrayMatriz) {
        claveInsumo = ClsUtil.bigintX(value.IdCodigoInsumo);
        calculado = this.mMapHCatalogo.get(claveInsumo).Calculado;
        if (!calculado) {
          this.mPila.push(IdCatalogo);
          this.mPila.push(claveInsumo);
          return;
        }
        //  calcula un renglon de la matriz
        this.cicloDetalleMatriz(value);
        if (this.mMapCostoHorariosCF.has(claveInsumo)) {
          claveCF = claveInsumo;
          hayUnCargoFijo = true;
        }
      }
      totOtr = 0; //  contiene el total de los importes de todos los renglones que son %
      // se procesan % de materiales, mano de obra y equipo
      arrayMatriz.forEach(value => {
        datosCatalogo = this.mMapHCatalogo.get(value.IdCodigoInsumo);
        if (datosCatalogo.EsPorcentaje) {
          totPar = 0;
          if (this.mMapHTipos.has(datosCatalogo.TipoPorcentaje)) {
            totPar = this.mMapHTipos.get(datosCatalogo.TipoPorcentaje);
          }
          if (value.Dividir) {
            if (value.Volumen === 0) {
              totPar = 0;
            } else {
              totPar = ClsUtil.redondearMoneda(totPar / value.Volumen, this.infPpto.decimalredondearimporte);
            }
          } else {
            totPar = ClsUtil.redondearMoneda(totPar * value.Volumen, this.infPpto.decimalredondearimporte);
          }
          totOtr = ClsUtil.redondearMoneda(totOtr + totPar, this.infPpto.decimalredondearimporte); // suma el importe del renglón al acumulado
          // se acumulan a materiales y mano de obra de esta matriz
          switch (datosCatalogo.TipoInsumo) {
            case 1:
              this.mTotMA2 = ClsUtil.redondearMoneda(this.mTotMA2 + totPar, this.infPpto.decimalredondearimporte);
              break;
            case 2:
              this.mTotMO2 = ClsUtil.redondearMoneda(this.mTotMO2 + totPar, this.infPpto.decimalredondearimporte);
              break;
          }
        }
      });
      costo1T = ClsUtil.redondearMoneda(this.mTotMatriz + totOtr, this.infPpto.decimalredondearimporte); // suma los % y los No % para obtener el importe total de la matriz
      // this.mCosto93 = ClsUtil.redondearMoneda(this.mTotMoGravableEstaMatriz);
      this.mCosto94 = ClsUtil.redondearMoneda(this.mMapHTipos.get(1) + this.mTotMA2, this.infPpto.decimalredondearimporte);
      this.mCosto95 = ClsUtil.redondearMoneda(this.mTotMA3 + this.mTotMA2, this.infPpto.decimalredondearimporte);
      this.mCosto96 = ClsUtil.redondearMoneda(this.mMapHTipos.get(2) + this.mTotMO2, this.infPpto.decimalredondearimporte);
      // this.mCosto97 = ClsUtil.redondearMoneda(this.mTotMO3);
      this.mCosto98 = ClsUtil.redondearMoneda(this.mTotMoTotal, this.infPpto.decimalredondearimporte);
      // se agregan los %mo y %ma a los acumulado incluyendo basicos
      datosCatalogo = this.mMapHCatalogo.get(IdCatalogo);
      // ESTO ACTUALIZA LA COLECCION
      // if (mDecimal > 4) {
      //   costo1T = costo1T
      // }
      // si la matriz tiene un CF (cargo fijo) se asume que es un Eq y se busca su costo en la hash de costos horarios
      if (hayUnCargoFijo) {
        if (this.mMapCostoHorariosCF.has(claveCF)) {
          datosTch = this.mMapCostoHorariosCF.get(claveCF);
          costo1T = datosTch.CostoActivoTotal;
        }
      }
      // cambioMatriz = datosCatalogo.CostoMoneda1 !== costo1T;
      datosCatalogo.Calculado = true;
      // if (!cambioMatriz) {
      //   this.mMapHCatalogo.set(IdCatalogo, datosCatalogo);
      //   return;
      // }
      // datos de la matriz no del insumo
      switch (this.mTipoMonedaCalcular) {
        case 0:
          datosCatalogo.CostoMoneda1 = costo1T;
          datosCatalogo.Costo93Moneda1 = this.mCosto93;
          datosCatalogo.Costo94Moneda1 = this.mCosto94;
          datosCatalogo.Costo95Moneda1 = this.mCosto95;
          datosCatalogo.Costo96Moneda1 = this.mCosto96;
          datosCatalogo.Costo97Moneda1 = this.mCosto97;
          datosCatalogo.Costo98Moneda1 = this.mCosto98;
          break;
        case 1:
          datosCatalogo.CostoMoneda2 = costo1T;
          datosCatalogo.Costo93Moneda2 = this.mCosto93;
          datosCatalogo.Costo94Moneda2 = this.mCosto94;
          datosCatalogo.Costo95Moneda2 = this.mCosto95;
          datosCatalogo.Costo96Moneda2 = this.mCosto96;
          datosCatalogo.Costo97Moneda2 = this.mCosto97;
          datosCatalogo.Costo98Moneda2 = this.mCosto98;
          break;
        case 2:
          break;
      }
      datosCatalogo.Nivel = this.nivelT + 1;
      // actualizar mMapHCatalogo
      this.mMapHCatalogo.set(IdCatalogo, datosCatalogo);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private cicloDetalleMatriz(datosMatriz: ClsCalculoMatriz) {
    let totPar: number;
    let moGravableRenglon: number;
    const datosCatalogo: ClsCalculoCatalogo = this.mMapHCatalogo.get(datosMatriz.IdCodigoInsumo);
    try {
      if (datosMatriz.Volumen !== 0) {
        if (!datosCatalogo.EsPorcentaje) {
          // Se suma al nivel temporal
          if (this.nivelT < datosCatalogo.Nivel) {
            this.nivelT = datosCatalogo.Nivel;
          }
          // se suma al correspondiente tipo
          // saber que moneda se esta calculando
          if (!datosMatriz.Dividir) {
            switch (this.mTipoMonedaCalcular) {
              case 0:
                totPar = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda1 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                break;
              case 1:
                totPar = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda2 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                break;
              case 2:
                break;
            }
          } else {
            switch (this.mTipoMonedaCalcular) {
              case 0:
                totPar = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda1 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                break;
              case 1:
                totPar = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda2 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                break;
              case 2:
                break;
            }
          }
          this.mTotMatriz = ClsUtil.redondearMoneda(this.mTotMatriz + totPar, this.infPpto.decimalredondearimporte); // acumula para tener el importe de la matriz
          if (datosCatalogo.TipoInsumo === 2) {
            const salarioRenglon = this.obtieneSalarioIntegrado(datosCatalogo.IdCatalogo);
            if (!datosMatriz.Dividir) {
              moGravableRenglon = ClsUtil.redondearMoneda(salarioRenglon * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
            } else {
              moGravableRenglon = ClsUtil.redondearMoneda(salarioRenglon / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
            }
            this.mTotMoGravableEstaMatriz = ClsUtil.redondearMoneda(this.mTotMoGravableEstaMatriz + moGravableRenglon, this.infPpto.decimalredondearimporte);
          }
          if (this.mMapHTipos.has(datosCatalogo.TipoInsumo)) {
            let saldo: number = this.mMapHTipos.get(datosCatalogo.TipoInsumo);
            saldo = ClsUtil.redondearMoneda(saldo + totPar, this.infPpto.decimalredondearimporte);
            this.mMapHTipos.set(datosCatalogo.TipoInsumo, saldo);
          } else {
            this.mMapHTipos.set(datosCatalogo.TipoInsumo, totPar);
          }
          if (datosCatalogo.Nivel === 0) {
            // se procesa como insumo
            switch (datosCatalogo.TipoInsumo) {
              case 1:
                // para materiales solo se acumula a materiales
                this.mTotMA3 = ClsUtil.redondearMoneda(this.mTotMA3 + totPar, this.infPpto.decimalredondearimporte);
                break;
              case 2:
                if (!datosMatriz.Dividir) {
                  switch (this.mTipoMonedaCalcular) {
                    case 0:
                      moGravableRenglon = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda1 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                      break;
                    case 1:
                      moGravableRenglon = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda2 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                      break;
                    case 2:
                      moGravableRenglon = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda3 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                      break;
                  }
                } else {
                  switch (this.mTipoMonedaCalcular) {
                    case 0:
                      moGravableRenglon = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda1 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                      break;
                    case 1:
                      moGravableRenglon = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda2 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                      break;
                    case 2:
                      moGravableRenglon = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda3 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                      break;
                  }
                }
                this.mTotMO3 = ClsUtil.redondearMoneda(this.mTotMO3 + moGravableRenglon, this.infPpto.decimalredondearimporte);
                this.mTotMoTotal = ClsUtil.redondearMoneda(this.mTotMoTotal + totPar, this.infPpto.decimalredondearimporte);
                break;
            }
          } else {
            // el nivel es mayor que cero, por lo tanto nada mas se procesan acumulados
            if (!datosMatriz.Dividir) {
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo95Moneda1 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 1:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo95Moneda2 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 2:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo95Moneda3 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
              }
            } else {
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo95Moneda1 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 1:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo95Moneda2 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 2:
                  break;
              }
            }
            // suma solo en caso de que sean de otro tipo diferente a 1 o 2
            this.mTotMA3 = ClsUtil.redondearMoneda(this.mTotMA3 + totPar, this.infPpto.decimalredondearimporte);
            // acumula mano de obra gravable
            if (!datosMatriz.Dividir) {
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda1 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 1:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda2 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 2:
                  break;
              }
            } else {
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda1 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 1:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo97Moneda2 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 2:
                  break;
              }
            }
            this.mTotMO3 = ClsUtil.redondearMoneda(this.mTotMO3 + totPar, this.infPpto.decimalredondearimporte);
            // acumula mano de obra total
            if (!datosMatriz.Dividir) {
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo98Moneda1 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 1:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo98Moneda2 * datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 2:
                  break;
              }
            } else {
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo98Moneda1 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 1:
                  totPar = ClsUtil.redondearMoneda(datosCatalogo.Costo98Moneda2 / datosMatriz.Volumen, this.infPpto.decimalredondearimporte);
                  break;
                case 2:
                  break;
              }
            }
            this.mTotMoTotal = ClsUtil.redondearMoneda(this.mTotMoTotal + totPar, this.infPpto.decimalredondearimporte);
          }
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calculaPreciosPresupuesto() {
    let idExpins: bigint;
    let datosCatalogo: ClsCalculoCatalogo;
    let datosPpto: ClsCalculoPresupuesto;
    let nivel: number;
    let indirL: boolean;
    let indirM: number;
    let cantidad: number;
    let precio: number;
    let importePrecio: number;
    let importeCosto: number;
    let acumParCosto: number;
    let acumParPrecio: number;
    let tidPresupuestoPartida: bigint; // Clave temporal del id de la partida para checar cuando ya cambió
    try {
      this.mMapJsonConceptos = new Map<bigint, ClsConceptosPartidasGuardar[]>();
      // validar si es calcular solo la explosion
      if (this.infPpto.pptoActivoCompletoJSON.Presupuesto.length > 0) {
        if (this.mTipoExplosion !== EnumTipoExpIns.NoCalcular) {
          this.mLPresupuesto = new Array<ClsCalculoPresupuesto>();
        }
      }
      this.mTotalPre = 0;
      this.mTotalCos = 0;
      tidPresupuestoPartida = BigInt('0');
      acumParPrecio = 0;
      acumParCosto = 0;
      // IdPresupuestoPartida para ordenar
      this.infPpto.pptoActivoCompletoJSON.Presupuesto.forEach(pptoCon => {
        idExpins = ClsUtil.bigintX(pptoCon.IdCatalogo);
        datosCatalogo = this.mMapHCatalogo.get(idExpins);
        nivel = datosCatalogo.Nivel;
        indirL = pptoCon.IndirectoEspecial;
        indirM = pptoCon.PorcentajeIndirectoEspecial;
        cantidad = ClsUtil.redondear(pptoCon.Cantidad, this.infPpto.decimalredondearcantidad);
        // Llenar el ArrayList de explosion de insumos del presupuesto
        if (this.mTipoExplosion !== EnumTipoExpIns.NoCalcular) {
          datosPpto = {
            Cantidad: cantidad,
            IdCatalogo: ClsUtil.bigintX(idExpins)
          };
          if (this.mTipoExplosion === EnumTipoExpIns.SoloLasMarcadas) {
            // solo las marcadas
            if (pptoCon.Marca) {
              this.mLPresupuesto.push(datosPpto);
            }
          } else {
            // todo el presupuesto
            this.mLPresupuesto.push(datosPpto);
          }
        }
        // queda pendiente de obtener el indirecto
        if (indirL) {
          precio = this.calculaPrecioUnitario(datosCatalogo, indirM);
        } else if (this.mTieneIndirecto) {
          precio = this.calculaPrecioUnitario(datosCatalogo, this.mValorSobrecosto);
        } else if (this.mTieneLibroPieIndirecto) {
          precio = this.calculaPrecioUnitarioLibroPieInd(datosCatalogo);
        } else {
          switch (this.mTipoMonedaCalcular) {
            case 0:
              precio = datosCatalogo.CostoMoneda1;
              break;
            case 1:
              precio = datosCatalogo.CostoMoneda2;
              break;
            case 2:
              break;
          }
        }
        // llenar mapa para JsonConceptos
        const idPptoPartida: bigint = ClsUtil.bigintX(pptoCon.IdPresupuestoPartida);
        let arrarJsonConcepto: ClsConceptosPartidasGuardar[] = [];
        const jsonConcepto: ClsConceptosPartidasGuardar = new ClsConceptosPartidasGuardar();
        jsonConcepto.IdCatalogo = idExpins;
        jsonConcepto.Control = pptoCon.Control;
        switch (this.mTipoMonedaCalcular) {
          case 0:
            jsonConcepto.PrecioMoneda1 = precio;
            jsonConcepto.PrecioMoneda2 = pptoCon.PrecioMoneda2;
            break;
          case 1:
            jsonConcepto.PrecioMoneda1 = pptoCon.PrecioMoneda1;
            jsonConcepto.PrecioMoneda2 = precio;
            break;
          case 2:
            break;
        }
        if (this.mMapJsonConceptos.has(idPptoPartida)) {
          arrarJsonConcepto = this.mMapJsonConceptos.get(idPptoPartida);
          arrarJsonConcepto.push(jsonConcepto);
        } else {
          arrarJsonConcepto.push(jsonConcepto);
        }
        // se agrega o actualiza
        this.mMapJsonConceptos.set(idPptoPartida, arrarJsonConcepto);
        importePrecio = ClsUtil.redondearMoneda(precio * cantidad, this.infPpto.decimalredondearimporte);
        switch (this.mTipoMonedaCalcular) {
          case 0:
            importeCosto = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda1 * cantidad, this.infPpto.decimalredondearimporte);
            break;
          case 1:
            importeCosto = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda2 * cantidad, this.infPpto.decimalredondearimporte);
            break;
          case 2:
            break;
        }
        this.mTotalPre = ClsUtil.redondearMoneda(this.mTotalPre + importePrecio, this.infPpto.decimalredondearimporte);
        this.mTotalCos = ClsUtil.redondearMoneda(this.mTotalCos + importeCosto, this.infPpto.decimalredondearimporte);
        // investiga si la partida anterior es diferente de la actual y en caso de que si
        // invoca la rutina recursiva para sumar los importes obtenidos a la hash de partidas
        if (tidPresupuestoPartida !== pptoCon.IdPresupuestoPartida) {
          if (tidPresupuestoPartida !== BigInt('0')) { // para filtrar la primera vez
            // invocar a la rutina recursiva para subir estos totales
            this.subeTotalesPartidas(tidPresupuestoPartida, acumParCosto, acumParPrecio);
          }
          acumParCosto = 0;
          acumParPrecio = 0;
          tidPresupuestoPartida = pptoCon.IdPresupuestoPartida;
        }
        acumParCosto = ClsUtil.redondearMoneda(acumParCosto + importeCosto, this.infPpto.decimalredondearimporte);
        acumParPrecio = ClsUtil.redondearMoneda(acumParPrecio + importePrecio, this.infPpto.decimalredondearimporte);
      });
      if (tidPresupuestoPartida !== BigInt('0')) { // para filtrar la primera vez o si hubo datos
        // invocar a la rutina recursiva para subir estos totales
        this.subeTotalesPartidas(tidPresupuestoPartida, acumParCosto, acumParPrecio);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calculaPrecioUnitario(datosCatalogo: ClsCalculoCatalogo, indirecto: number): number {
    let precio: number;
    switch (this.mTipoMonedaCalcular) {
      case 0:
        precio = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda1 * indirecto / 100, this.infPpto.decimalredondearimporte);
        precio = ClsUtil.redondearMoneda(precio + datosCatalogo.CostoMoneda1, this.infPpto.decimalredondearimporte);
        break;
      case 1:
        precio = ClsUtil.redondearMoneda(datosCatalogo.CostoMoneda2 * indirecto / 100, this.infPpto.decimalredondearimporte);
        precio = ClsUtil.redondearMoneda(precio + datosCatalogo.CostoMoneda2, this.infPpto.decimalredondearimporte);
        break;
      case 2:
        break;
    }
    return precio;
  }

  private calculaPrecioUnitarioLibroPieInd(datosCatalogo: ClsCalculoCatalogo): number {
    let precio: number;
    switch (this.mTipoMonedaCalcular) {
      case 0:
        this.mObjSobrecosto.FactorIndirecto = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBINDIRECTOTOTAL1).Valor);
        this.mObjSobrecosto.FactorIndirectosOficinaCentral = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBINDIRECTOOFICINA1).Valor);
        this.mObjSobrecosto.FactorIndirectosCampo = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBINDIRECTOCAMPO1).Valor);
        this.mObjSobrecosto.FactorFinanciamiento = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBFINANCIAMIENTO1).Valor);
        this.mObjSobrecosto.FactorUtilidad = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBUTILIDAD1).Valor);
        this.mObjSobrecosto.FactorCargosAdicionales = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBCARGOSADICIONALES1).Valor);
        this.mObjSobrecosto.Costo93 = datosCatalogo.Costo93Moneda1;
        this.mObjSobrecosto.Costo94 = datosCatalogo.Costo94Moneda1;
        this.mObjSobrecosto.Costo95 = datosCatalogo.Costo95Moneda1;
        this.mObjSobrecosto.Costo96 = datosCatalogo.Costo96Moneda1;
        this.mObjSobrecosto.Costo97 = datosCatalogo.Costo97Moneda1;
        this.mObjSobrecosto.Costo98 = datosCatalogo.Costo98Moneda1;
        this.mObjSobrecosto.Costo99 = datosCatalogo.CostoMoneda1;
        this.mObjSobrecosto.MLIBRO = this.infPpto.docPieIndSelec1.Workbook;
        this.mObjSobrecosto.MESLIBROINDIRECTO = true;
        this.mObjSobrecosto.setValoresHojaPieIndirecto();
        precio = ClsUtil.redondearMoneda(this.mObjSobrecosto.FactorIndirectoPie + 100, this.infPpto.decimalredondearimporte);
        break;
      case 1:
        this.mObjSobrecosto.FactorIndirecto = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBINDIRECTOTOTAL2).Valor);
        this.mObjSobrecosto.FactorIndirectosOficinaCentral = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBINDIRECTOOFICINA2).Valor);
        this.mObjSobrecosto.FactorIndirectosCampo = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBINDIRECTOCAMPO2).Valor);
        this.mObjSobrecosto.FactorFinanciamiento = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBFINANCIAMIENTO2).Valor);
        this.mObjSobrecosto.FactorUtilidad = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBUTILIDAD2).Valor);
        this.mObjSobrecosto.FactorCargosAdicionales = Number(this.paramSobrecosto.find(para => para.Parametro === EnumParaPpto.SOBCARGOSADICIONALES2).Valor);
        this.mObjSobrecosto.Costo93 = datosCatalogo.Costo93Moneda2;
        this.mObjSobrecosto.Costo94 = datosCatalogo.Costo94Moneda2;
        this.mObjSobrecosto.Costo95 = datosCatalogo.Costo95Moneda2;
        this.mObjSobrecosto.Costo96 = datosCatalogo.Costo96Moneda2;
        this.mObjSobrecosto.Costo97 = datosCatalogo.Costo97Moneda2;
        this.mObjSobrecosto.Costo98 = datosCatalogo.Costo98Moneda2;
        this.mObjSobrecosto.Costo99 = datosCatalogo.CostoMoneda2;
        this.mObjSobrecosto.MLIBRO = this.infPpto.docPieIndSelec2.Workbook;
        this.mObjSobrecosto.MESLIBROINDIRECTO = true;
        this.mObjSobrecosto.setValoresHojaPieIndirecto();
        precio = ClsUtil.redondearMoneda(this.mObjSobrecosto.FactorIndirectoPie + 100, this.infPpto.decimalredondearimporte);
        break;
      case 2:
        break;
    }
    return precio;
  }

  private subeTotalesPartidas(idPresupuestoPartida: bigint, acumParCosto: number, acumParPrecio: number) {
    let datosPartidas: ClsCalculoPartidas;
    let idPartidaPadre: bigint;
    // 1o. toma los datos actuales en memoria de la partida
    datosPartidas = this.mMapHPartidas.get(idPresupuestoPartida);
    // 2o. suma los datos que viene como parametro a los datos en memoria
    switch (this.mTipoMonedaCalcular) {
      case 0:
        datosPartidas.Costo1 = ClsUtil.redondearMoneda(datosPartidas.Costo1 + acumParCosto, this.infPpto.decimalredondearimporte);
        datosPartidas.Precio1 = ClsUtil.redondearMoneda(datosPartidas.Precio1 + acumParPrecio, this.infPpto.decimalredondearimporte);
        break;
      case 1:
        datosPartidas.Costo2 = ClsUtil.redondearMoneda(datosPartidas.Costo2 + acumParCosto, this.infPpto.decimalredondearimporte);
        datosPartidas.Precio2 = ClsUtil.redondearMoneda(datosPartidas.Precio2 + acumParPrecio, this.infPpto.decimalredondearimporte);
        break;
      case 2:
        break;
    }
    // 3o. los actualiza en la hash en memoria
    this.mMapHPartidas.set(idPresupuestoPartida, datosPartidas);
    // 4o. obtiene su padre y en caso de que lo tenga llama de nuevo la rutina hasta que ya no tenga padre
    idPartidaPadre = datosPartidas.IdPartidaPadre;
    if (idPartidaPadre > BigInt('0')) {
      this.subeTotalesPartidas(idPartidaPadre, acumParCosto, acumParPrecio);
    }
  }

  private explotaPresupuesto() {
    try {
      // ordenar mMapHCatalogo Nivel > 0 y Nivel DESC
      const arrayCatalogo: ClsCalculoOrderNivel[] = ClsUtil.ordenarMapXNivelDesc(this.mMapHCatalogo);
      this.mMapHExplosion = new Map<bigint, number>();
      this.mLExplosion = new Array<bigint>();
      // this.mMapHExpInsumos = new Map<bigint, ClsCatalogosExpIns>();
      arrayCatalogo.forEach(expIns => {
        this.mLExplosion.push(ClsUtil.bigintX(expIns.IdCatalogo));
      });
      this.llenaTodoPresupuesto(); // LLenar datos con todo el presupuesto
      this.calculaExpIns(); // calcula la explosion de insumos de las colecciones llenas
      if (this.mTipoExplosion === EnumTipoExpIns.DeTodoElPresupuesto) {
        // si se calculo explosion de todo el presupuesto se ajusta la explosion
        this.ajustarExplosion(this.mTotalCos, this.infPpto.decimalredondearexpins);
      }
      if (this.mTipoExplosion === EnumTipoExpIns.SoloLasMarcadas) {
        this.redondearExplosion();
      }
      this.calculaMOGravable()
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private llenaTodoPresupuesto() {
    try {
      this.mMapHExplosion.clear();
      if (!ClsUtil.esNulo(this.mLPresupuesto)) {
        this.mLPresupuesto.forEach(datosPpto => {
          this.sumaCantidad(ClsUtil.bigintX(datosPpto.IdCatalogo), datosPpto.Cantidad);
        });
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calculaExpIns() {
    let expIns2: number;
    let datosCatalogo: ClsCalculoCatalogo;
    try {
      if (this.mMapHExplosion.size === 0) {
        return;
      }
      this.mLExplosion.forEach(claveTmp => {
        if (this.mMapHExplosion.has(claveTmp)) {
          expIns2 = this.mMapHExplosion.get(claveTmp);
          if (this.mMapHCatalogo.has(claveTmp)) {
            datosCatalogo = this.mMapHCatalogo.get(claveTmp);
            if (datosCatalogo.Nivel > 0) {
              if (datosCatalogo.TchFij === EnumTipoTchFij.NoEsTch) {
                if (datosCatalogo.InsumoIntegrado) {
                  if (this.mExplotarInsumosIntegrados) {
                    this.explotaUnaMatriz(claveTmp, expIns2);
                  }
                } else {
                  this.explotaUnaMatriz(claveTmp, expIns2);
                }
              } else if (datosCatalogo.TchFij === EnumTipoTchFij.CostoHorario) {
                if (this.mExplotarInsumoCH) {
                  if (datosCatalogo.InsumoIntegrado) {
                    if (this.mExplotarInsumosIntegrados) {
                      this.explotaUnaMatriz(claveTmp, expIns2);
                    }
                  } else {
                    this.explotaUnaMatriz(claveTmp, expIns2);
                  }
                }
              }
            }
          }
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private sumaCantidad(claveCat: bigint, cantidad: number) {
    if (!this.mMapHExplosion.has(claveCat)) {
      // agregar
      this.mMapHExplosion.set(claveCat, cantidad);
    } else {
      //  actualizar
      const cant: number = this.mMapHExplosion.get(claveCat);
      this.mMapHExplosion.set(claveCat, cant + cantidad);
    }
  }

  /**
   * Esta funcion regresa el salario integrado de una categoria dada,
   * este se utiliza para el calculo de los costos que tienen que ver con la mano de obra gravable
   * @param idCatalogo
   */
  private obtieneSalarioIntegrado(idCatalogo: bigint) {
    let salarioIntegrado = 0;
    if (this.mMapHCostoMOCalculo.has(idCatalogo)) {
      switch (this.mTipoMonedaCalcular) {
        case 0:
          salarioIntegrado = this.mMapHCostoMOCalculo.get(idCatalogo).SalarioIntegradoMoneda1;
          break;
        case 1:
          salarioIntegrado = this.mMapHCostoMOCalculo.get(idCatalogo).SalarioIntegradoMoneda2;
          break;
        default:
          salarioIntegrado = this.mMapHCostoMOCalculo.get(idCatalogo).SalarioIntegradoMoneda3;
          break;
      }
    }
    return salarioIntegrado;
  }

  private explotaUnaMatriz(claveMatriz: bigint, cantidad: number) {
    let arrayMatriz: ClsCalculoMatriz[];
    let volumen: number;
    let claveInsumo: bigint;
    let multiplicar: boolean;
    let cantidadExp: number;
    let monto: number;
    let parcial: number;
    let datosCatalogo: ClsCalculoCatalogo;
    try {
      if (!this.mMapHMatriz.has(claveMatriz)) {
        return;
      }
      arrayMatriz = this.mMapHMatriz.get(claveMatriz);
      this.mMapHTipos.clear();
      arrayMatriz.forEach(matriz => {
        claveInsumo = ClsUtil.bigintX(matriz.IdCodigoInsumo);
        volumen = matriz.Volumen;
        multiplicar = !matriz.Dividir;
        if (this.mMapHCatalogo.has(claveInsumo)) {
          datosCatalogo = this.mMapHCatalogo.get(claveInsumo);
          if (!datosCatalogo.EsPorcentaje) {
            if (!multiplicar) {
              cantidadExp = 0;
              if (volumen !== 0) {
                cantidadExp = cantidad / volumen;
              }
            } else {
              cantidadExp = cantidad * volumen;
            }
            switch (this.mTipoMonedaCalcular) {
              case 0:
                monto = cantidadExp * datosCatalogo.CostoMoneda1;
                break;
              case 1:
                monto = cantidadExp * datosCatalogo.CostoMoneda2;
                break;
              case 2:
                break;
            }
            if (this.mMapHTipos.has(datosCatalogo.TipoInsumo)) {
              const cant: number = this.mMapHTipos.get(datosCatalogo.TipoInsumo);
              this.mMapHTipos.set(datosCatalogo.TipoInsumo, monto + cant);
            } else {
              this.mMapHTipos.set(datosCatalogo.TipoInsumo, monto);
            }
            this.sumaCantidad(claveInsumo, cantidadExp);
          }
        }
      });

      arrayMatriz.forEach(matriz => {
        claveInsumo = ClsUtil.bigintX(matriz.IdCodigoInsumo);
        volumen = matriz.Volumen;
        multiplicar = !matriz.Dividir;
        if (this.mMapHCatalogo.has(claveInsumo)) {
          datosCatalogo = this.mMapHCatalogo.get(claveInsumo);
          if (datosCatalogo.EsPorcentaje) {
            parcial = 0;
            if (this.mMapHTipos.has(datosCatalogo.TipoPorcentaje)) {
              parcial = this.mMapHTipos.get(datosCatalogo.TipoPorcentaje);
            }
            if (multiplicar) {
              monto = parcial * volumen;
            } else {
              monto = parcial / volumen;
            }
            this.sumaCantidad(claveInsumo, monto);
          }
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
    if (!this.mMapHMatriz.has(claveMatriz)) {
      return;
    }
  }

  private ajustarExplosion(importeAjuste: number, decimalesExplosion: number) {
    let totalExplosion: number;
    let clave: bigint;
    let cantidad: number;
    let datosCatalogo: ClsCalculoCatalogo;
    let valor: number;
    let tExpinsl: number;
    let totalPorcen: number;
    let diferencia: number;
    let factorAjuste: number;
    let totalAjuste: number;
    let expins: number;
    let parcialAjuste: number;
    const mapPorcentajes: Map<bigint, number> = new Map<bigint, number>();
    const decImp: number = this.infPpto.decimalredondearimporte;
    try {
      if (this.mMapHExplosion.size === 0) {
        return;
      }
      totalExplosion = 0;
      totalPorcen = 0;
      mapPorcentajes.clear();
      this.mMapHExplosion.forEach((value, key) => {
        clave = key;
        cantidad = this.mMapHExplosion.get(clave);
        datosCatalogo = this.mMapHCatalogo.get(clave);
        // decimal es a 8 de la exp
        valor = ClsUtil.redondear(cantidad, decimalesExplosion);
        tExpinsl = this.calculaExpinsL(datosCatalogo);
        if (tExpinsl === 1) {
          if (!datosCatalogo.EsPorcentaje) {
            switch (this.mTipoMonedaCalcular) {
              case 0:
                totalExplosion = ClsUtil.redondearMoneda(totalExplosion + ClsUtil.redondearMoneda(valor * datosCatalogo.CostoMoneda1, decImp), decImp);
                break;
              case 1:
                totalExplosion = ClsUtil.redondearMoneda(totalExplosion + ClsUtil.redondearMoneda(valor * datosCatalogo.CostoMoneda2, decImp), decImp);
                break;
              case 2:
                break;
            }
          } else {
            // es un porcentaje
            valor = ClsUtil.redondearMoneda(valor, decImp);
            totalExplosion = ClsUtil.redondearMoneda(totalExplosion + valor, decImp);
            totalPorcen = ClsUtil.redondearMoneda(totalPorcen + valor, decImp);
            mapPorcentajes.set(clave, valor);
          }
        }
        // grabar el dato redondeado
        this.mMapHExplosion.set(clave, valor);
      });
      // se calcula la diferencia
      diferencia = ClsUtil.redondearMoneda(importeAjuste - totalExplosion, decImp);
      if (diferencia === 0) {
        return;
      }
      //  si es menos del 20% de la suma de % sale del sistema
      if (totalPorcen === 0 || totalPorcen * 0.8 < Math.abs(diferencia)) {
        return;
      }
      // se procede al ajuste del porcentaje
      factorAjuste = diferencia / totalPorcen;
      totalAjuste = 0;
      mapPorcentajes.forEach((value, key) => {
        clave = key;
        expins = mapPorcentajes.get(clave);
        parcialAjuste = ClsUtil.redondearMoneda(expins * factorAjuste, decImp);
        totalAjuste = ClsUtil.redondearMoneda(totalAjuste + parcialAjuste, decImp);
        expins = ClsUtil.redondearMoneda(expins + parcialAjuste, decImp);
        // grabar el dato redondeado
        mapPorcentajes.set(clave, expins);
      });
      diferencia = ClsUtil.redondearMoneda(diferencia - totalAjuste, decImp);
      if (diferencia !== 0) {
        for (const [clave, valor] of mapPorcentajes) {
          let expins = valor;

          if ((expins + diferencia) > 0) {
            expins = ClsUtil.redondearMoneda(expins + diferencia, decImp);
            mapPorcentajes.set(clave, expins);
            break; // ✅ detiene el loop correctamente
          }
        }
      }
      // graba a la hash mhexplosion los conceptos que son % con el dato nuevo ya ajustado
      mapPorcentajes.forEach((value, key) => {
        clave = key;
        expins = value;
        this.mMapHExplosion.set(clave, expins);
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calculaMOGravable() {
    const decImp: number = this.infPpto.decimalredondearimporte;
    const decExp: number = this.infPpto.decimalredondearexpins;
    try {
      if (this.mMapHExplosion.size === 0) {
        return;
      }
      this.mTotalMOGravable = 0;
      this.mMapHExplosion.forEach((value, key) => {
        const cantidad = this.mMapHExplosion.get(key);
        const datosCatalogo = this.mMapHCatalogo.get(key);
        // decimal es a 8 de la exp
        const cantidadRedondeada = ClsUtil.redondear(cantidad, decExp);
        const tExpinsl = this.calculaExpinsL(datosCatalogo);
        if (tExpinsl === 1) {
          if (!datosCatalogo.EsPorcentaje && datosCatalogo.TipoInsumo === 2) {
            if (this.mMapHCostoMOCalculo.has(key)) {
              const datosMO = this.mMapHCostoMOCalculo.get(key);
              let salarioIntegrado = 0;
              switch (this.mTipoMonedaCalcular) {
                case 0:
                  salarioIntegrado = datosMO?.SalarioIntegradoMoneda1 || 0;
                  this.mTotalMOGravable = ClsUtil.redondearMoneda(this.mTotalMOGravable + ClsUtil.redondearMoneda(cantidadRedondeada * salarioIntegrado, decImp), decImp);
                  break;
                case 1:
                  salarioIntegrado = datosMO?.SalarioIntegradoMoneda2 || 0;
                  this.mTotalMOGravable = ClsUtil.redondearMoneda(this.mTotalMOGravable + ClsUtil.redondearMoneda(cantidadRedondeada * salarioIntegrado, decImp), decImp);
                  break;
                case 2:
                  break;
              }
            }
          }
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private redondearExplosion() {
    let cantidad: number;
    let valor: number;
    this.mMapHExplosion.forEach((value, key) => {
      cantidad = this.mMapHExplosion.get(key);
      // decimal es a 8 de la exp
      valor = ClsUtil.redondear(cantidad, this.infPpto.decimalredondearexpins);
      // grabar el dato redondeado
      this.mMapHExplosion.set(key, valor);
    });
  }

  private calculaExpinsL(datosCatalogo: ClsCalculoCatalogo): number {
    let tExpinsL = 0;
    if (datosCatalogo.Nivel === 0) {
      tExpinsL = 1;
    } else {
      if (this.mExplotarInsumoCH) {
        if (datosCatalogo.TchFij === EnumTipoTchFij.CargoFijo) {
          tExpinsL = 1;
        }
      } else {
        if (datosCatalogo.TchFij === EnumTipoTchFij.CostoHorario) {
          tExpinsL = 1;
        }
      }
      if (datosCatalogo.InsumoIntegrado && !this.mExplotarInsumosIntegrados) {
        tExpinsL = 1;
      }
    }
    return tExpinsL;
  }

  private explotaConceptos() {
    try {
      if (!ClsUtil.esNulo(this.mLPresupuesto)) {
        this.mLPresupuesto.forEach(datosPpto => {
          const idCat: bigint = ClsUtil.bigintX(datosPpto.IdCatalogo);
          if (!this.mMapHExpXConcepto.has(idCat)) {
            let datosCatalogo: ClsCalculoCatalogo;
            let totalCostoExplosion: number;
            this.mMapHExplosion.clear();
            datosCatalogo = this.mMapHCatalogo.get(idCat);
            switch (this.mTipoMonedaCalcular) {
              case 0:
                totalCostoExplosion = datosCatalogo.CostoMoneda1;
                break;
              case 1:
                totalCostoExplosion = datosCatalogo.CostoMoneda2;
                break;
              case 2:
                break;
            }
            this.sumaCantidad(idCat, 1);
            this.calculaExpIns();
            this.ajustarExplosion(totalCostoExplosion, 10);
            this.generarDatosExpXConcepto(idCat);
          }
        });
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private generarDatosExpXConcepto(idCat: bigint) {
    const detalle: ClsCalculoDetalleExpXConcepto[] = [];
    let datosCatalogo: ClsCalculoCatalogo;
    let tExpinsl: number;
    try {
      this.mMapHExplosion.forEach((cantidad, key) => {
        datosCatalogo = this.mMapHCatalogo.get(key);
        if (cantidad > 0) {
          tExpinsl = this.calculaExpinsL(datosCatalogo);
          if (tExpinsl === 1) {
            const det: ClsCalculoDetalleExpXConcepto = {
              IdCatalogo: key,
              Expins: ClsUtil.redondear(cantidad, 10)
            };
            detalle.push(det);
          }
        }
      });
      if (!this.mMapHExpXConcepto.has(idCat)) {
        this.mMapHExpXConcepto.set(idCat, detalle);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calculaUnCostoHorario(idCF: bigint) {
    let idE: bigint;
    let idR: bigint;
    let costoA: number;
    let costoE: number;
    let costoR: number;
    let costoOpe: number;
    let costoOC: number;
    let costoActivoTotal: number;
    let datosCatalogo: ClsCalculoCatalogo;
    const ch: ClsCostoHorarios = this.mMapCostoHorariosCF.get(idCF);
    this.nivelT = 0; // Pone el nivel base del CH

    idE = ClsUtil.bigintX(ch.IdCatalogoE);
    idR = ClsUtil.bigintX(ch.IdCatalogoR);
    this.limpiaLibroDatosParticulares();
    if (ch.LsCostosHorariosMO.length > 0) {
      this.vaciaOperacionAExcel(ch.LsCostosHorariosMO);
    }
    if (ch.LsCostosHorariosOC.length > 0) {
      this.vaciaOtrosConsumosAExcel(ch.LsCostosHorariosOC);
    }
    this.vaciaDatosExcel(ch);
    this.mHojaDatos.unprotect();
    costoA = ClsUtil.redondearMoneda(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoCargoFijoA').value), this.infPpto.decimalredondearimporte);
    costoE = ClsUtil.redondearMoneda(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoEspera').value), this.infPpto.decimalredondearimporte);
    costoR = ClsUtil.redondearMoneda(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoReserva').value), this.infPpto.decimalredondearimporte);
    costoOpe = ClsUtil.redondearMoneda(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoOperacionA').value), this.infPpto.decimalredondearimporte);
    costoOC = ClsUtil.redondearMoneda(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoConsumoA').value), this.infPpto.decimalredondearimporte);

    costoActivoTotal = ClsUtil.redondearMoneda(costoA + costoOpe + costoOC, this.infPpto.decimalredondearimporte);
    // actualiza ch
    ch.CostoActivo = costoA;
    ch.CostoOperacion = costoOpe;
    ch.CostoConsumos = costoOC;
    ch.CostoActivoTotal = costoActivoTotal;
    // actualizar datos del mapa con los campos CA, CO, CC, CAT
    this.mMapCostoHorariosCF.set(idCF, ch);
    // actualiza a la hash de catalogo
    datosCatalogo = this.mMapHCatalogo.get(idCF);
    if (!datosCatalogo.Calculado) {
      datosCatalogo.Calculado = true;
      switch (this.mTipoMonedaCalcular) {
        case 0:
          datosCatalogo.CostoMoneda1 = costoA;
          break;
        case 1:
          datosCatalogo.CostoMoneda2 = costoA;
          break;
        case 2:
          break;
      }
      datosCatalogo.TchFij = EnumTipoTchFij.CargoFijo;
      datosCatalogo.Nivel = this.nivelT + 1;
      this.mMapHCatalogo.set(idCF, datosCatalogo);
    }

    //  actualiza espera y reserva si es necesario
    if (idE > BigInt('0')) {
      datosCatalogo = this.mMapHCatalogo.get(idE);
      if (!datosCatalogo.Calculado) {
        datosCatalogo.Calculado = true;
        switch (this.mTipoMonedaCalcular) {
          case 0:
            datosCatalogo.CostoMoneda1 = costoE;
            break;
          case 1:
            datosCatalogo.CostoMoneda2 = costoE;
            break;
          case 2:
            break;
        }
        this.mMapHCatalogo.set(idE, datosCatalogo);
      }
    }
    if (idR > BigInt('0')) {
      datosCatalogo = this.mMapHCatalogo.get(idR);
      if (!datosCatalogo.Calculado) {
        datosCatalogo.Calculado = true;
        switch (this.mTipoMonedaCalcular) {
          case 0:
            datosCatalogo.CostoMoneda1 = costoR;
            break;
          case 1:
            datosCatalogo.CostoMoneda2 = costoR;
            break;
          case 2:
            break;
        }
        this.mMapHCatalogo.set(idR, datosCatalogo);
      }
    }
  }

  //#region Costo Horario
  private limpiaLibroDatosParticulares() {
    try {
      // this.mHojaDatos.getCell('CodigoEquipo').value = '';
      // this.mHojaDatos.getCell('DescripcionEquipo').value = '';
      // this.mHojaDatos.getCell('Modelo').value = '';
      // this.mHojaDatos.getCell('NumeroDeSerie').value = '';
      // this.mHojaDatos.getCell('Capacidad').value = '';
      this.mHojaDatos.unprotect();
      this.mHojaDatos.getCell('PrecioAdquisicion').value = 0;
      this.mHojaDatos.getCell('PrecioLlantas').value = 0;
      this.mHojaDatos.getCell('VidaEcoLlantasHrs').value = 0;
      this.mHojaDatos.getCell('CostoPzsEsp').value = 0;
      this.mHojaDatos.getCell('VidaEcoPiezasHrs').value = 0;
      this.mHojaDatos.getCell('ValorRescate').value = 0;
      this.mHojaDatos.getCell('TasaInteres').value = 0;
      this.mHojaDatos.getCell('PrimaSeguros').value = 0;
      this.mHojaDatos.getCell('HorasXAño').value = 0;
      this.mHojaDatos.getCell('VidaEcoEQHrs').value = 0;
      this.mHojaDatos.getCell('PotenciaNominal').value = 0;
      this.mHojaDatos.getCell('CostoCombustible').value = 0;
      this.mHojaDatos.getCell('Combustible').value = '';
      this.mHojaDatos.getCell('CostoLubricante').value = 0;
      this.mHojaDatos.getCell('FactorOperacion').value = 0;
      this.mHojaDatos.getCell('FactorMantenimiento').value = 0;
      this.mHojaDatos.getCell('CostoOtrasFuentes').value = 0;
      this.mHojaDatos.getCell('FactorOtrasFuentes').value = 0;
      this.mHojaDatos.getCell('CostoOtrasFuentes').value = 0;
      this.mHojaDatos.getCell('OtrasFuentesDeEnergia').value = '';
      this.mHojaDatos.getCell('ConsumosDetallado').value = 1;
      this.mHojaDatos.getCell('FactorCombustible').value = 0;
      this.mHojaDatos.getCell('FactorLubricante').value = 0;
      this.mHojaDatos.getCell('CapacidadCarter').value = 0;
      this.mHojaDatos.getCell('TiempoCambioLub').value = 0;
      this.mHojaDatos.getCell('CantidadCombustible_sinDetalle').value = 0;
      this.mHojaDatos.getCell('CantidadLubricante_sinDetalle').value = 0;
      this.mHojaDatos.getCell('ExplotarInsumosCH').value = this.mExplotarInsumoCH ? 1 : 0;
      // ESTE DATO SE CALCULA EN LA HOJA DE EXCEL
      this.mHojaDatos.getCell('PrecioEquipoAdicional').value = 0;
      // LIMPIA EL CUADRO DE OPERACIÓN
      this.limpiaDatosOperacion();
      // LIMPIA EL CUADRO DE OTROS CONSUMOS
      this.limpiaDatosOtrosConsumos();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public vaciaDatosExcel(ch: ClsCostoHorarios) {
    const IdVA: bigint = ClsUtil.bigintX(ch.IdCatalogoVa);
    const IdLla: bigint = ClsUtil.bigintX(ch.IdCatalogoLla);
    const IdPza: bigint = ClsUtil.bigintX(ch.IdCatalogoPza);
    const IdCom: bigint = ClsUtil.bigintX(ch.IdCatalogoComb);
    const IdLub: bigint = ClsUtil.bigintX(ch.IdCatalogoAcei);
    const IdOFE: bigint = ClsUtil.bigintX(ch.IdCatalogoOtrasFuentes);
    let costoVA = 0;
    let costoLla = 0;
    let costoPza = 0;
    let costoComb = 0;
    let costoLub = 0;
    let costoOtrasFue = 0;
    // agregar VA
    if (IdVA > BigInt('0')) {
      const catVA: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdVA);
      costoVA = this.mTipoMonedaCalcular === 0 ? catVA.CostoMoneda1 : catVA.CostoMoneda2;
    }
    // agregar Lla
    if (IdLla > BigInt('0')) {
      const catLla: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdLla);
      costoLla = this.mTipoMonedaCalcular === 0 ? catLla.CostoMoneda1 : catLla.CostoMoneda2;
    }
    // agregar Pza
    if (IdPza > BigInt('0')) {
      const catPza: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdPza);
      costoPza = this.mTipoMonedaCalcular === 0 ? catPza.CostoMoneda1 : catPza.CostoMoneda2;
    }
    // agregar Combustible
    if (IdCom > BigInt('0')) {
      const catComb: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdCom);
      costoComb = this.mTipoMonedaCalcular === 0 ? catComb.CostoMoneda1 : catComb.CostoMoneda2;
    }
    // agregar Lubricante
    if (IdLub > BigInt('0')) {
      const catLub: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdLub);
      costoLub = this.mTipoMonedaCalcular === 0 ? catLub.CostoMoneda1 : catLub.CostoMoneda2;
    }
    // agregar Otras Fuentes
    if (IdOFE > BigInt('0')) {
      const catOtrasFue: ClsCalculoCatalogo = this.mMapHCatalogo.get(IdOFE);
      costoOtrasFue = this.mTipoMonedaCalcular === 0 ? catOtrasFue.CostoMoneda1 : catOtrasFue.CostoMoneda2;
    }
    this.mHojaDatos.unprotect();
    this.mHojaDatos.getCell('PrecioAdquisicion').value = costoVA;
    this.mHojaDatos.getCell('PrecioLlantas').value = costoLla;
    this.mHojaDatos.getCell('CostoPzsEsp').value = costoPza;
    this.mHojaDatos.getCell('CostoCombustible').value = costoComb;
    this.mHojaDatos.getCell('CostoLubricante').value = costoLub;
    this.mHojaDatos.getCell('CostoOtrasFuentes').value = costoOtrasFue;

    this.mHojaDatos.getCell('VidaEcoLlantasHrs').value = ch.Hllantas;
    this.mHojaDatos.getCell('VidaEcoPiezasHrs').value = ch.HPiezas;
    this.mHojaDatos.getCell('ValorRescate').value = ch.Vr / 100;
    this.mHojaDatos.getCell('TasaInteres').value = this.mTipoMonedaCalcular === 0 ? ch.TasaInteresMoneda1 / 100 : ch.TasaInteresMoneda2 / 100;
    this.mHojaDatos.getCell('PrimaSeguros').value = ch.S / 100;
    this.mHojaDatos.getCell('HorasXAño').value = ch.Ha;
    this.mHojaDatos.getCell('VidaEcoEQHrs').value = ch.Ve;
    this.mHojaDatos.getCell('PotenciaNominal').value = ch.Potencia;
    this.mHojaDatos.getCell('FactorOperacion').value = ch.Foper / 100;
    this.mHojaDatos.getCell('FactorMantenimiento').value = ch.Q;
    this.mHojaDatos.getCell('FactorOtrasFuentes').value = ch.FactFuentes;

    if (ch.CalculoDetallado) {
      this.mHojaDatos.getCell('ConsumosDetallado').value = 1;
      this.mHojaDatos.getCell('FactorCombustible').value = ch.Factcomb;
      this.mHojaDatos.getCell('FactorLubricante').value = ch.Faceite;
      this.mHojaDatos.getCell('CapacidadCarter').value = ch.Ccarter;
      this.mHojaDatos.getCell('TiempoCambioLub').value = ch.Horasc;
    } else {
      this.mHojaDatos.getCell('ConsumosDetallado').value = 0;
      this.mHojaDatos.getCell('CantidadCombustible_sinDetalle').value = ch.CantidadCombustible;
      this.mHojaDatos.getCell('CantidadLubricante_sinDetalle').value = ch.CantidadLubricante;
    }
  }

  public vaciaOperacionAExcel(ope: ClsLsJsonCostosHorariosMO[]) {
    try {
      let fila = 0;
      let columna = 0;
      let costo: number;
      let importe: number;
      this.mHojaDatos.unprotect();
      fila = this.mHojaDatos.getCell('InicioOperacion').rowIndex;
      columna = this.mHojaDatos.getCell('InicioOperacion').columnIndex;
      ope.forEach(value => {
        const idMO: bigint = ClsUtil.bigintX(value.IdCatalogoMO);
        if (this.mMapHCatalogo.has(idMO)) {
          const cat: ClsCalculoCatalogo = this.mMapHCatalogo.get(idMO);
          costo = this.mTipoMonedaCalcular === 0 ? cat.CostoMoneda1 : cat.CostoMoneda2;
          importe = (value.Volumen > 0) ? ClsUtil.redondearMoneda(costo / value.Volumen) : 0;
          this.mHojaDatos.rows(fila + 1).cells(columna).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = value.Volumen;
          this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = costo;
          this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = importe;
        }
        fila += 1;
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public vaciaOtrosConsumosAExcel(otrosCon: ClsLsJsonCostosHorariosOC[]) {
    try {
      let fila = 0;
      let columna = 0;
      let costo: number;
      let importe: number;
      this.mHojaDatos.unprotect();
      fila = this.mHojaDatos.getCell('InicioOtrosConsumos').rowIndex;
      columna = this.mHojaDatos.getCell('InicioOtrosConsumos').columnIndex;
      otrosCon.forEach(value => {
        const idOC: bigint = ClsUtil.bigintX(value.IdCatalogoOC);
        if (this.mMapHCatalogo.has(idOC)) {
          const cat: ClsCalculoCatalogo = this.mMapHCatalogo.get(idOC);
          costo = this.mTipoMonedaCalcular === 0 ? cat.CostoMoneda1 : cat.CostoMoneda2;
          importe = ClsUtil.redondearMoneda(costo * value.Volumen);
          this.mHojaDatos.rows(fila + 1).cells(columna).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = '';
          this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = value.Volumen;
          this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = costo;
          this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = '*';
          this.mHojaDatos.rows(fila + 1).cells(columna + 7).value = importe;
        }
        fila += 1;
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private limpiaDatosOperacion() {
    let fila: number;
    let columna: number;
    this.mHojaDatos.unprotect();
    fila = this.mHojaDatos.getCell('InicioOperacion').rowIndex;
    columna = this.mHojaDatos.getCell('InicioOperacion').columnIndex;
    for (let i = 0; i <= (this.mObjCostoHorario.mMaximoMo - 1); i++) {
      this.mHojaDatos.rows(fila + 1).cells(columna).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = 0;
      fila += 1;
    }
  }

  private limpiaDatosOtrosConsumos() {
    let fila: number;
    let columna: number;
    this.mHojaDatos.unprotect();
    fila = this.mHojaDatos.getCell('InicioOtrosConsumos').rowIndex;
    columna = this.mHojaDatos.getCell('InicioOtrosConsumos').columnIndex;
    for (let i = 0; i <= (this.mObjCostoHorario.mMaximoOc - 1); i++) {
      this.mHojaDatos.rows(fila + 1).cells(columna).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 7).value = 0;
      fila += 1;
    }
  }

  //#endregion

  //#region Traduccion
  public getTranslationsAlertReferenciaCircular(): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.REFERENCIA_CIRCULAR_CALCULO'], this.infApp)['MENSAJES.ALERT.REFERENCIA_CIRCULAR_CALCULO'].toString();
  }

  //#endregion
}
